export const HamburgerIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-5 h-5"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
      />
    </svg>
  );
};
export const BookIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="sm:w-5 sm:h-5 w-6 h-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 0 0-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 0 0-16.536-1.84M7.5 14.25 5.106 5.272M6 20.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm12.75 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
      />
    </svg>
  );
};

export const MoveIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-5 h-5"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 12c0-1.232-.046-2.453-.138-3.662a4.006 4.006 0 00-3.7-3.7 48.678 48.678 0 00-7.324 0 4.006 4.006 0 00-3.7 3.7c-.017.22-.032.441-.046.662M19.5 12l3-3m-3 3l-3-3m-12 3c0 1.232.046 2.453.138 3.662a4.006 4.006 0 003.7 3.7 48.656 48.656 0 007.324 0 4.006 4.006 0 003.7-3.7c.017-.22.032-.441.046-.662M4.5 12l3 3m-3-3l-3 3"
      />
    </svg>
  );
};
export const CheckIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-5 h-5"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4.5 12.75l6 6 9-13.5"
      />
    </svg>
  );
};
export const XIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-6 h-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6 18L18 6M6 6l12 12"
      />
    </svg>
  );
};
export const UsersIcon = ({ className = "sm:w-5 sm:h-5 w-6 h-6" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={className}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z"
      />
    </svg>
  );
};
export const BigUsersIcon = ({ className = "w-8 h-8" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className={className}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z"
      />
    </svg>
  );
};
export const HomeIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="sm:w-5 sm:h-5 w-6 h-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3.75 6A2.25 2.25 0 0 1 6 3.75h2.25A2.25 2.25 0 0 1 10.5 6v2.25a2.25 2.25 0 0 1-2.25 2.25H6a2.25 2.25 0 0 1-2.25-2.25V6ZM3.75 15.75A2.25 2.25 0 0 1 6 13.5h2.25a2.25 2.25 0 0 1 2.25 2.25V18a2.25 2.25 0 0 1-2.25 2.25H6A2.25 2.25 0 0 1 3.75 18v-2.25ZM13.5 6a2.25 2.25 0 0 1 2.25-2.25H18A2.25 2.25 0 0 1 20.25 6v2.25A2.25 2.25 0 0 1 18 10.5h-2.25a2.25 2.25 0 0 1-2.25-2.25V6ZM13.5 15.75a2.25 2.25 0 0 1 2.25-2.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-2.25A2.25 2.25 0 0 1 13.5 18v-2.25Z"
      />
    </svg>
  );
};
export const SettingsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="sm:w-5 sm:h-5 w-6 h-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
      />
    </svg>
  );
};
export const LogoutIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="sm:w-5 sm:h-5 w-6 h-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75"
      />
    </svg>
  );
};
export const EmailIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-5 h-5"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
      />
    </svg>
  );
};
export const TrendingUpIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-6 h-6 -mb-3 text-success"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2.25 18L9 11.25l4.306 4.307a11.95 11.95 0 015.814-5.519l2.74-1.22m0 0l-5.94-2.28m5.94 2.28l-2.28 5.941"
      />
    </svg>
  );
};
export const TrendingDownIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-6 h-6 -mb-3 text-danger"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2.25 6L9 12.75l4.286-4.286a11.948 11.948 0 014.306 6.43l.776 2.898m0 0l3.182-5.511m-3.182 5.51l-5.511-3.181"
      />
    </svg>
  );
};
export const PasswordIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-5 h-5"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"
      />
    </svg>
  );
};
export const GarbageIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-5 h-5 text-red-400 transitionColors hover:text-red-500"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
      />
    </svg>
  );
};
export const StartIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-5 h-5"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z"
      />
    </svg>
  );
};
export const StopIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-5 h-5"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5.25 7.5A2.25 2.25 0 017.5 5.25h9a2.25 2.25 0 012.25 2.25v9a2.25 2.25 0 01-2.25 2.25h-9a2.25 2.25 0 01-2.25-2.25v-9z"
      />
    </svg>
  );
};
export const ClockIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="800"
      height="800"
      fill="none"
      viewBox="0 0 24 24"
      className="sm:w-5 sm:h-5 w-6 h-6"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M12 8v4l2.5 2.5"
      ></path>
      <path
        fill="currentColor"
        d="M5.604 5.604l-.53-.53.53.53zM4.338 6.871l-.75.003a.75.75 0 00.746.747l.004-.75zm2.542.762a.75.75 0 10.007-1.5l-.007 1.5zM5.075 4.321a.75.75 0 00-1.5.008l1.5-.008zM3.75 12a.75.75 0 00-1.5 0h1.5zm13.125 8.445a.75.75 0 10-.75-1.298l.75 1.298zm2.272-4.32a.75.75 0 101.298.75l-1.298-.75zM5.14 5.07a.75.75 0 101.056 1.066L5.14 5.071zm13.722.067c-3.82-3.82-9.993-3.859-13.788-.064l1.06 1.06c3.2-3.199 8.423-3.18 11.668.065l1.06-1.061zM5.074 5.074L3.808 6.34l1.06 1.06 1.267-1.265-1.061-1.061zm-.74 2.547l2.546.012.007-1.5-2.545-.012-.008 1.5zm.754-.754L5.075 4.32l-1.5.008.013 2.545 1.5-.007zM12 3.75A8.25 8.25 0 0120.25 12h1.5c0-5.385-4.365-9.75-9.75-9.75v1.5zm0 16.5A8.25 8.25 0 013.75 12h-1.5c0 5.385 4.365 9.75 9.75 9.75v-1.5zm4.125-1.103A8.209 8.209 0 0112 20.25v1.5c1.775 0 3.44-.475 4.875-1.305l-.75-1.298zM20.25 12a8.209 8.209 0 01-1.103 4.125l1.298.75A9.708 9.708 0 0021.75 12h-1.5zM6.196 6.137A8.221 8.221 0 0112 3.75v-1.5a9.721 9.721 0 00-6.86 2.821l1.056 1.066z"
      ></path>
    </svg>
  );
};
export const BigClockIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-10 h-10"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  );
};
export const EditIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-5 h-5 text-neutral-900 dark:text-neutral-400 transitionColors hover:text-neutral-800 dark:hover:text-neutral-200"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
      />
    </svg>
  );
};
export const ChevronUp = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-4 h-4"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4.5 15.75l7.5-7.5 7.5 7.5"
      />
    </svg>
  );
};
export const ChevronDown = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-4 h-4"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 8.25l-7.5 7.5-7.5-7.5"
      />
    </svg>
  );
};

export const ChevronIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      className="w-5 h-5 group-hover:translate-x-1.5 transition-transform"
    >
      <path
        fillRule="evenodd"
        d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export const GameIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="sm:w-5 sm:h-5 w-6 h-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16.5 18.75h-9m9 0a3 3 0 0 1 3 3h-15a3 3 0 0 1 3-3m9 0v-3.375c0-.621-.503-1.125-1.125-1.125h-.871M7.5 18.75v-3.375c0-.621.504-1.125 1.125-1.125h.872m5.007 0H9.497m5.007 0a7.454 7.454 0 0 1-.982-3.172M9.497 14.25a7.454 7.454 0 0 0 .981-3.172M5.25 4.236c-.982.143-1.954.317-2.916.52A6.003 6.003 0 0 0 7.73 9.728M5.25 4.236V4.5c0 2.108.966 3.99 2.48 5.228M5.25 4.236V2.721C7.456 2.41 9.71 2.25 12 2.25c2.291 0 4.545.16 6.75.47v1.516M7.73 9.728a6.726 6.726 0 0 0 2.748 1.35m8.272-6.842V4.5c0 2.108-.966 3.99-2.48 5.228m2.48-5.492a46.32 46.32 0 0 1 2.916.52 6.003 6.003 0 0 1-5.395 4.972m0 0a6.726 6.726 0 0 1-2.749 1.35m0 0a6.772 6.772 0 0 1-3.044 0"
      />
    </svg>
  );
};
export const MoneyIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-10 h-10 text-success"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 00-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 01-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 003 15h-.75M15 10.5a3 3 0 11-6 0 3 3 0 016 0zm3 0h.008v.008H18V10.5zm-12 0h.008v.008H6V10.5z"
      />
    </svg>
  );
};
export const FacebookIcon = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.2267 0H3.77306C1.6893 0 0 1.68923 0 3.77306V24.2268C0 26.3106 1.68923 27.9999 3.77306 27.9999H13.8607L13.8779 17.9942H11.2784C10.9406 17.9942 10.6664 17.7211 10.6651 17.3832L10.6526 14.158C10.6513 13.8184 10.9263 13.5423 11.266 13.5423H13.8608V10.4259C13.8608 6.80938 16.0695 4.84014 19.2957 4.84014H21.943C22.2818 4.84014 22.5564 5.11474 22.5564 5.45352V8.17305C22.5564 8.51169 22.282 8.78622 21.9434 8.78642L20.3187 8.78718C18.5642 8.78718 18.2245 9.6209 18.2245 10.8444V13.5424H22.0798C22.4471 13.5424 22.7321 13.8631 22.6888 14.228L22.3065 17.4532C22.27 17.7618 22.0083 17.9944 21.6975 17.9944H18.2417L18.2245 28H24.2268C26.3106 28 27.9998 26.3108 27.9998 24.227V3.77306C27.9997 1.68923 26.3105 0 24.2267 0Z"
        fill="white"
      />
    </svg>
  );
};
export const InstagramIcon = () => {
  return (
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.9122 7.53818C14.6659 7.53818 14.4224 7.55076 14.1824 7.57538C13.9425 7.6 13.7058 7.63649 13.4732 7.68439C13.2406 7.73228 13.0122 7.79159 12.7883 7.8616L12.1311 8.10333L11.5054 8.40599L10.915 8.7659L10.3634 9.17927L9.8543 9.64252L9.39143 10.152L8.97835 10.7041L8.61865 11.295L8.31635 11.9211C8.22548 12.1353 8.14466 12.3548 8.07469 12.5789C8.00473 12.803 7.94552 13.0318 7.89762 13.2646C7.84972 13.4973 7.8133 13.7341 7.78863 13.9743C7.76397 14.2145 7.75159 14.4582 7.75159 14.7047C7.75159 14.9511 7.76415 15.1948 7.78863 15.435C7.81298 15.6733 7.84936 15.9102 7.89762 16.1448C7.94552 16.3785 8.00473 16.6064 8.07469 16.8305C8.14466 17.0546 8.22539 17.274 8.31635 17.4883L8.61865 18.1144L8.97835 18.7052L9.39143 19.2573L9.8543 19.7669L10.3634 20.2301L10.915 20.6435L11.5054 21.0034L12.1311 21.3061L12.7883 21.5478L13.4732 21.725C13.7077 21.7733 13.9443 21.8097 14.1824 21.8341C14.4249 21.8589 14.6684 21.8713 14.9122 21.8712C15.1584 21.8712 15.4019 21.8586 15.6418 21.8341C15.8799 21.8097 16.1166 21.7733 16.351 21.725L17.036 21.5478L17.6932 21.3061L18.3188 21.0034L18.9093 20.6435L19.461 20.2301L19.9701 19.7669L20.433 19.2573L20.846 18.7052L21.2057 18.1144L21.508 17.4883L21.7497 16.8305C21.8197 16.6064 21.8789 16.3776 21.9268 16.1448L22.0358 15.4349C22.0603 15.1947 22.0729 14.951 22.0729 14.7046C22.0729 14.4582 22.0603 14.2144 22.0358 13.9742C22.0114 13.736 21.975 13.4991 21.9268 13.2645C21.8789 13.0308 21.8197 12.803 21.7497 12.5788L21.508 11.921L21.2057 11.2949L20.846 10.704L20.433 10.152L19.9701 9.64243L19.461 9.17918L18.9093 8.76581L18.3188 8.4059L17.6932 8.10324L17.036 7.86151L16.351 7.68429L15.6418 7.57529C15.3994 7.55049 15.1558 7.53807 14.9122 7.53809V7.53818ZM14.9122 10.0118C15.075 10.0118 15.2356 10.0199 15.3939 10.0359L15.8603 10.1066L16.3109 10.2216L16.7423 10.3786L17.1526 10.5754L17.5383 10.8095L17.8989 11.0788L18.2313 11.3809L18.5332 11.7136L18.8023 12.0745L19.0362 12.4615L19.2327 12.8721C19.2917 13.0127 19.3441 13.1567 19.3896 13.304C19.4352 13.4513 19.4735 13.6018 19.5045 13.7551C19.5354 13.9085 19.5583 14.0645 19.5751 14.2229L19.5991 14.7051C19.5991 14.868 19.591 15.0289 19.5751 15.1874C19.5591 15.3459 19.5356 15.5019 19.5045 15.6551C19.4733 15.8084 19.4349 15.9589 19.3896 16.1063L19.2327 16.5381L19.0362 16.9488L18.8023 17.3357L18.5332 17.6967L18.2313 18.0293L17.8989 18.3315L17.5383 18.6008L17.1526 18.8349L16.7423 19.0317L16.3109 19.1887L15.8603 19.3037L15.3939 19.3743C15.2338 19.3904 15.073 19.3985 14.9121 19.3984C14.7511 19.3985 14.5903 19.3904 14.4302 19.3743L13.9637 19.3037C13.8106 19.2726 13.6603 19.2342 13.5131 19.1887L13.0816 19.0317L12.6714 18.8349L12.2857 18.6008L11.9251 18.3315L11.5926 18.0293L11.2908 17.6967L11.0217 17.3357L10.7877 16.9488L10.5913 16.5381L10.4343 16.1063L10.3195 15.6551L10.2489 15.1874C10.2328 15.0271 10.2248 14.8662 10.2249 14.7051C10.2248 14.5441 10.2328 14.3831 10.2489 14.2229C10.2648 14.0645 10.2884 13.9084 10.3195 13.7551C10.3503 13.603 10.3887 13.4525 10.4344 13.3041L10.5914 12.8722L10.7878 12.4616L11.0218 12.0746L11.2909 11.7137L11.5927 11.381L11.9252 11.0789L12.2858 10.8096L12.6715 10.5755L13.0817 10.3787C13.2229 10.3193 13.3669 10.2669 13.5132 10.2217L13.9639 10.1067C14.117 10.0756 14.2729 10.0519 14.4304 10.0359C14.5905 10.0199 14.7513 10.0118 14.9122 10.0119L14.9122 10.0118Z"
        fill="white"
      />
      <path
        d="M22.3631 5.49951C22.3063 5.49952 22.2495 5.5024 22.1929 5.50814C22.1363 5.51387 22.0801 5.52244 22.0243 5.53384C21.9686 5.54522 21.9135 5.55941 21.8592 5.57635C21.8049 5.59329 21.7514 5.61297 21.6991 5.6353C21.6467 5.65765 21.5955 5.68264 21.5456 5.71015C21.4957 5.73762 21.4472 5.76758 21.4003 5.79993C21.3533 5.83231 21.308 5.86704 21.2646 5.90399C21.2211 5.9409 21.1795 5.97998 21.1399 6.02108C21.1003 6.06221 21.0627 6.10531 21.0274 6.15022C20.992 6.19513 20.959 6.2418 20.9283 6.29005C20.8976 6.33825 20.8693 6.38798 20.8435 6.43904C20.8177 6.49014 20.7944 6.5425 20.7738 6.59594C20.7532 6.64937 20.7353 6.70381 20.7201 6.75905C20.7049 6.81428 20.6924 6.87024 20.6827 6.92673C20.6731 6.98321 20.6662 7.04013 20.6622 7.09729C20.6593 7.13779 20.6579 7.17837 20.6579 7.21897C20.6579 7.27632 20.6607 7.33364 20.6664 7.3907C20.6721 7.44774 20.6806 7.50445 20.6919 7.56063C20.7032 7.61681 20.7173 7.67239 20.7341 7.72715C20.7509 7.78193 20.7704 7.83582 20.7925 7.88864C20.8147 7.94146 20.8395 7.99314 20.8667 8.04347C20.894 8.0938 20.9237 8.14271 20.9558 8.19004C20.9879 8.23734 21.0223 8.28299 21.059 8.32681C21.0956 8.37068 21.1343 8.41267 21.1751 8.45262C21.2159 8.49256 21.2587 8.53041 21.3032 8.56603C21.3478 8.60168 21.394 8.63506 21.4419 8.66605C21.4898 8.69704 21.5391 8.72559 21.5898 8.7516C21.6405 8.77762 21.6924 8.80108 21.7454 8.82187C21.7983 8.84264 21.8523 8.86073 21.9071 8.87606C21.9619 8.89137 22.0174 8.90391 22.0734 8.91363C22.1294 8.92338 22.1859 8.93031 22.2426 8.93438C22.2827 8.93726 22.323 8.9387 22.3632 8.9387C22.4201 8.93872 22.4769 8.93587 22.5335 8.93016C22.5901 8.92443 22.6463 8.91585 22.702 8.90446C22.7577 8.89308 22.8129 8.87889 22.8672 8.86195C22.9215 8.84501 22.9749 8.82533 23.0273 8.803C23.0797 8.78068 23.1309 8.75572 23.1808 8.72824C23.2307 8.70074 23.2792 8.67075 23.3261 8.63837C23.373 8.60602 23.4183 8.57132 23.4618 8.5344C23.5053 8.49746 23.5469 8.45835 23.5865 8.41722C23.6261 8.37609 23.6636 8.33299 23.699 8.28808C23.7343 8.24317 23.7674 8.1965 23.7981 8.14825C23.8288 8.10002 23.8571 8.05026 23.8829 7.99917C23.9087 7.94807 23.9319 7.89571 23.9526 7.84227C23.9732 7.78884 23.9911 7.7344 24.0063 7.67916C24.0215 7.62393 24.034 7.56797 24.0436 7.51148C24.0533 7.455 24.0601 7.39808 24.0642 7.34092C24.067 7.30042 24.0685 7.25984 24.0685 7.21924C24.0685 7.16192 24.0656 7.10463 24.0599 7.0476C24.0543 6.99056 24.0458 6.93385 24.0345 6.87767C24.0232 6.82149 24.0091 6.76591 23.9923 6.71115C23.9755 6.65637 23.956 6.60247 23.9338 6.54966C23.9117 6.49684 23.8869 6.44516 23.8596 6.39483C23.8324 6.3445 23.8027 6.29559 23.7706 6.24826C23.7384 6.20093 23.704 6.15525 23.6673 6.1114C23.6307 6.06754 23.592 6.02555 23.5512 5.98559C23.5104 5.94565 23.4677 5.9078 23.4231 5.87218C23.3786 5.83656 23.3323 5.80321 23.2845 5.77225C23.2366 5.74126 23.1872 5.71271 23.1365 5.6867C23.0859 5.66067 23.034 5.63722 22.981 5.61642C22.928 5.59565 22.874 5.57757 22.8193 5.56224C22.7645 5.5469 22.709 5.53433 22.653 5.52458C22.5969 5.51486 22.5405 5.50796 22.4838 5.50391C22.4436 5.50104 22.4034 5.4996 22.3631 5.4996V5.49951Z"
        fill="white"
      />
      <path
        d="M13.5542 0.684588C12.7754 0.683329 12.0804 0.686564 11.4561 0.695371L9.78224 0.740303C9.28637 0.76187 8.84826 0.789996 8.45501 0.82639C8.25838 0.844543 8.07288 0.864852 7.89706 0.887229C7.72975 0.908354 7.5629 0.932953 7.39661 0.961008C7.23829 0.987967 7.08804 1.01708 6.94398 1.04871C6.79991 1.08035 6.66231 1.1145 6.52955 1.15116C6.39977 1.18701 6.271 1.22645 6.14338 1.26942C6.01834 1.31166 5.89634 1.35641 5.77587 1.40422C5.53493 1.49983 5.29991 1.60713 5.0579 1.72737C4.87168 1.81993 4.69963 1.91366 4.53619 2.01287C4.37275 2.11208 4.21793 2.21686 4.06633 2.33098C3.91021 2.44909 3.75973 2.5745 3.6154 2.7068C3.46452 2.84447 3.31041 2.99589 3.15029 3.1651C2.94909 3.37655 2.77426 3.57371 2.61907 3.76719C2.54148 3.86389 2.46882 3.9595 2.40038 4.05565C2.33269 4.15042 2.26799 4.24728 2.20635 4.34609C2.14536 4.44405 2.08759 4.5438 2.03233 4.64642C1.97621 4.75081 1.92318 4.85684 1.87329 4.96436C1.77121 5.18399 1.67594 5.42051 1.58086 5.68453C1.51032 5.87972 1.44715 6.0775 1.3915 6.27745C1.33472 6.4818 1.28422 6.69559 1.23918 6.92681C1.19415 7.15803 1.15486 7.40668 1.12033 7.68167C1.08311 7.98309 1.05338 8.2854 1.03117 8.5883C1.00605 8.92134 0.985238 9.28781 0.968194 9.6957L0.927828 11.0519L0.90612 12.7052L0.899841 14.7035L0.91823 17.6094L0.97564 19.8111L1.01986 20.6711L1.07512 21.3837C1.09283 21.5758 1.115 21.7674 1.14159 21.9585C1.16581 22.1281 1.19182 22.2766 1.21981 22.4051C1.2766 22.6663 1.34375 22.9252 1.4211 23.1811C1.49517 23.4262 1.57987 23.6678 1.67496 23.9054C1.76843 24.1382 1.87069 24.3627 1.98192 24.5787C2.09315 24.7947 2.21335 25.0023 2.34252 25.2017C2.47169 25.4011 2.60983 25.5924 2.7573 25.7754C2.90461 25.9585 3.06129 26.1338 3.22672 26.3006C3.3924 26.4677 3.56714 26.6268 3.75129 26.7779C3.93763 26.9308 4.13132 27.0745 4.33167 27.2084C4.51762 27.3329 4.7016 27.447 4.88693 27.5517C5.07225 27.6564 5.25919 27.7514 5.45133 27.8377C5.64347 27.9241 5.84046 28.0018 6.04624 28.0717C6.25201 28.1416 6.4664 28.2038 6.69299 28.259C6.91958 28.3142 7.15944 28.3626 7.4133 28.4048C7.66715 28.4471 7.9385 28.4833 8.22842 28.5145C8.51834 28.5457 8.82763 28.5715 9.15998 28.593C9.49232 28.6146 9.84755 28.6318 10.2292 28.6457C10.8188 28.6671 11.7114 28.6796 12.7406 28.6843L16.0726 28.6776L19.2278 28.6333L20.4275 28.5995L21.209 28.5592C21.3768 28.5456 21.5409 28.5294 21.6994 28.5104C21.8578 28.4915 22.014 28.4698 22.1662 28.4452C22.3183 28.4206 22.467 28.3931 22.6132 28.3625C22.7576 28.3324 22.9013 28.2987 23.0441 28.2616C23.1855 28.2257 23.3249 28.1848 23.4628 28.1414C23.6008 28.098 23.7373 28.0511 23.873 28.0007C24.0095 27.9501 24.1448 27.8961 24.2787 27.8389C24.4135 27.7814 24.5481 27.7199 24.6832 27.6547C24.8907 27.5546 25.0577 27.4711 25.2044 27.3896C25.3423 27.3137 25.4752 27.229 25.6021 27.1358C25.7273 27.0434 25.8519 26.9383 25.9954 26.8058C26.1389 26.6733 26.3015 26.5137 26.5029 26.3119C26.6799 26.1347 26.8292 25.9807 26.9579 25.8406C27.0866 25.7005 27.1951 25.5744 27.2901 25.4529C27.3808 25.3376 27.4652 25.2176 27.5431 25.0933C27.6191 24.972 27.689 24.846 27.7604 24.7062C27.8676 24.4959 27.9631 24.3012 28.0486 24.1133C28.1316 23.9322 28.2074 23.7479 28.2759 23.5608C28.3433 23.3752 28.4017 23.1864 28.4509 22.9951C28.5015 22.7983 28.5451 22.5906 28.5827 22.3627C28.6204 22.1348 28.6523 21.8867 28.6799 21.6098C28.7075 21.3328 28.731 21.0267 28.7517 20.6828L28.8064 19.5284L28.8534 18.0926L28.8869 16.493L28.8998 14.8205L28.8699 11.5355L28.8298 10.0641L28.7751 8.80083L28.7069 7.81592C28.6821 7.54184 28.6554 7.32599 28.6271 7.18005C28.5957 7.0188 28.5606 6.85829 28.5219 6.69864C28.4843 6.54331 28.4428 6.3889 28.3977 6.23558C28.3537 6.08619 28.3059 5.93796 28.2543 5.79102C28.2034 5.64589 28.1494 5.50381 28.0929 5.36479C28.0364 5.22577 27.9752 5.08999 27.9115 4.95708C27.8478 4.82417 27.7811 4.6945 27.711 4.56779C27.641 4.44108 27.5679 4.31752 27.4916 4.19701C27.4153 4.0765 27.3358 3.95905 27.253 3.84474C27.1707 3.7308 27.0848 3.61947 26.9956 3.5109C26.9067 3.40293 26.8145 3.29779 26.7191 3.19566C26.6238 3.09365 26.5253 2.99469 26.4237 2.89893C26.3221 2.80313 26.2174 2.71039 26.1094 2.62071C26.001 2.53073 25.8898 2.44415 25.7761 2.36109C25.6611 2.27718 25.5436 2.19681 25.4237 2.12008C25.3022 2.04225 25.1784 1.96805 25.0525 1.89757C24.9244 1.82591 24.7943 1.75795 24.6623 1.69376C24.4433 1.58709 24.2407 1.49246 24.0418 1.40853C23.8464 1.32523 23.6471 1.25125 23.4446 1.18684C23.241 1.12258 23.029 1.0675 22.7958 1.01996C22.5626 0.972421 22.3083 0.932791 22.0204 0.899092C21.7325 0.865393 21.4111 0.838165 21.0435 0.815519C20.6759 0.792874 20.2625 0.775079 19.7904 0.760701L18.186 0.724756L16.1554 0.700762L13.5551 0.684766L13.5542 0.684588ZM14.9047 3.15603L18.6545 3.17741L20.0691 3.20473C20.4587 3.2157 20.756 3.22855 20.9303 3.24337C21.1572 3.26251 21.3734 3.28651 21.5801 3.31527C21.7786 3.34272 21.976 3.37685 22.1722 3.41762C22.3606 3.45716 22.5402 3.50209 22.7122 3.55278C22.8841 3.60346 23.0484 3.66025 23.206 3.72307C23.3636 3.78588 23.5143 3.85499 23.6594 3.93065C23.8032 4.00575 23.9431 4.08839 24.0783 4.17823C24.2128 4.26764 24.3425 4.36398 24.4685 4.46777C24.5944 4.57156 24.7165 4.68281 24.8357 4.80179C24.9616 4.92733 25.0776 5.05521 25.1846 5.18713C25.2913 5.31823 25.3899 5.45564 25.48 5.59862C25.5712 5.74363 25.6533 5.89414 25.726 6.04929C25.8003 6.20745 25.867 6.3746 25.9269 6.55226C25.9869 6.72992 26.0402 6.91872 26.0875 7.12047C26.137 7.33435 26.1785 7.55003 26.2118 7.76704C26.2477 7.99709 26.2784 8.24242 26.3044 8.50509C26.3304 8.76776 26.3519 9.04787 26.3697 9.34757C26.3839 9.58795 26.3963 9.90517 26.4067 10.2798L26.433 11.5572L26.4531 14.6863L26.4303 17.8124L26.4028 19.0861L26.365 20.0125C26.3388 20.4463 26.3112 20.811 26.2782 21.1284C26.2616 21.2871 26.2437 21.4339 26.2238 21.5717C26.2051 21.7018 26.183 21.8315 26.1575 21.9604C26.1341 22.0781 26.1071 22.195 26.0763 22.3109C26.0468 22.4215 26.0136 22.5311 25.9768 22.6395C25.9397 22.7484 25.8994 22.8562 25.8558 22.9627C25.8097 23.0751 25.7611 23.1865 25.71 23.2967C25.6646 23.3951 25.6167 23.4908 25.5661 23.584C25.5161 23.6762 25.463 23.7668 25.4068 23.8554C25.3512 23.9432 25.2929 24.0285 25.2319 24.1111C25.1713 24.1934 25.1077 24.2735 25.0412 24.3512C24.975 24.4286 24.906 24.5035 24.8343 24.5758C24.7625 24.6482 24.6881 24.718 24.6109 24.7854C24.5338 24.8528 24.4538 24.9175 24.371 24.9799C24.2882 25.0422 24.2025 25.1021 24.114 25.1594C24.0254 25.2167 23.9341 25.2717 23.8398 25.3242C23.7456 25.3767 23.6483 25.4268 23.5483 25.4746C23.4465 25.523 23.3434 25.5684 23.2389 25.6106C23.1309 25.6543 23.0218 25.6949 22.9115 25.7324C22.6872 25.8089 22.4507 25.8762 22.2017 25.9341C21.9422 25.9942 21.6802 26.0433 21.4166 26.0813C21.3153 26.0962 21.0823 26.1101 20.7486 26.123L19.477 26.1584L15.8719 26.2053L12.0984 26.2113L10.6166 26.1955L9.65433 26.1654L8.94478 26.1155C8.72447 26.0969 8.51959 26.0762 8.32763 26.0527C8.13567 26.0293 7.95689 26.0031 7.7887 25.9737C7.62932 25.9461 7.4709 25.9131 7.31373 25.8748C7.17042 25.8399 7.02857 25.7992 6.88854 25.7528C6.75354 25.7078 6.62446 25.6584 6.49887 25.6041C6.37329 25.5497 6.2513 25.4901 6.13047 25.425C6.00964 25.36 5.89006 25.2894 5.76915 25.2123C5.67792 25.1543 5.58974 25.0955 5.50488 25.0332C5.42003 24.971 5.33804 24.9089 5.2591 24.8438C5.18016 24.7787 5.10436 24.7117 5.03126 24.6427C4.95863 24.574 4.8885 24.5027 4.82099 24.429C4.75372 24.3555 4.6894 24.2798 4.62769 24.2015C4.56573 24.1228 4.5067 24.0419 4.4507 23.9588C4.39388 23.8745 4.34011 23.7882 4.28951 23.7C4.23838 23.6111 4.18976 23.519 4.14356 23.4241C4.09659 23.3274 4.05276 23.2292 4.01215 23.1297C3.97089 23.0283 3.93178 22.9237 3.895 22.8157C3.82144 22.5995 3.75686 22.3695 3.7007 22.1242C3.64455 21.8788 3.59665 21.6182 3.5561 21.3405C3.51556 21.0629 3.48291 20.7685 3.45689 20.4556C3.4377 20.2251 3.42245 19.8661 3.41079 19.4131L3.38639 17.8023L3.39536 13.696L3.46595 9.77217L3.51977 8.38971L3.55027 7.93275C3.56086 7.81071 3.5718 7.72031 3.58301 7.66603C3.61997 7.48747 3.6572 7.32131 3.69568 7.16576C3.73163 7.01901 3.77162 6.87328 3.81561 6.72875C3.85741 6.59234 3.90146 6.46455 3.94855 6.3435C3.99396 6.22624 4.04457 6.11107 4.10024 5.99833C4.1546 5.8887 4.21299 5.78374 4.27641 5.68156C4.33983 5.57939 4.40827 5.48027 4.48291 5.38169C4.55754 5.28311 4.63791 5.18578 4.72537 5.08711C4.81283 4.98844 4.90729 4.88878 5.00973 4.78607C5.12912 4.66579 5.25343 4.55051 5.38235 4.44054C5.50408 4.33679 5.63103 4.23934 5.76269 4.14857C5.89213 4.05871 6.02489 3.97873 6.16312 3.90522C6.30135 3.83171 6.44505 3.7653 6.5962 3.70554C6.74735 3.64579 6.90612 3.59232 7.07431 3.54379C7.25101 3.49414 7.42967 3.45177 7.60983 3.41681C7.79929 3.37961 8.00049 3.34717 8.21532 3.31886C8.43016 3.29055 8.65872 3.26611 8.90307 3.2449C9.07351 3.23016 9.36719 3.21704 9.7539 3.20599L11.1613 3.17813L14.9053 3.15522L14.9047 3.15603Z"
        fill="white"
      />
    </svg>
  );
};
export const CardIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-10 h-10 text-success"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z"
      />
    </svg>
  );
};
export const PoolIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="800"
      height="800"
      fill="none"
      viewBox="0 0 24 24"
      className="sm:w-5 sm:h-5 w-6 h-6 "
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12 14v-3m0-5a7.5 7.5 0 105.547 2.453M12 6a7.48 7.48 0 015.547 2.453M12 6V3m7.5 3.5l-1.953 1.953M12 3H9m3 0h3"
      ></path>
    </svg>
  );
};
export const PauseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-5 h-5"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.75 5.25v13.5m-7.5-13.5v13.5"
      />
    </svg>
  );
};
export const UserIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_123_181)">
        <path
          d="M49.7059 0.147095C36.5488 0.224949 23.9593 5.51622 14.697 14.8611C5.43475 24.2059 0.255419 36.8419 0.294346 49.9992C0.333273 63.1564 5.58728 75.7616 14.9047 85.0514C24.2221 94.3413 36.8427 99.558 50 99.558C63.1574 99.558 75.7779 94.3413 85.0953 85.0514C94.4127 75.7616 99.6668 63.1564 99.7057 49.9992C99.7446 36.8419 94.5653 24.2059 85.303 14.8611C76.0408 5.51622 63.4512 0.224949 50.2941 0.147095H49.7059ZM49.7059 25.4412C55.6083 25.5189 61.2403 27.9281 65.3729 32.1431C69.5055 36.358 71.8031 42.0365 71.7642 47.9393C71.7254 53.842 69.3533 59.4898 65.1656 63.65C60.9779 67.8103 55.3147 70.1452 49.4118 70.1452C43.5089 70.1452 37.8456 67.8103 33.6579 63.65C29.4703 59.4898 27.0982 53.842 27.0593 47.9393C27.0205 42.0365 29.3181 36.358 33.4506 32.1431C37.5832 27.9281 43.2153 25.5189 49.1177 25.4412H49.7059ZM16.7647 84.4118C22.0588 77.5491 28.6275 74.1177 36.4706 74.1177H63.5294C71.3726 74.1177 77.9412 77.5491 83.2353 84.4118C74.2694 92.9358 62.3712 97.6891 50 97.6891C37.6288 97.6891 25.7306 92.9358 16.7647 84.4118Z"
          fill="#DDDDDD"
        />
      </g>
      <defs>
        <clipPath id="clip0_123_181">
          <rect width="100" height="100" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const InformationIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-4 h-4"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
      />
    </svg>
  );
};

export const RefreshIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-4 h-4"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
      />
    </svg>
  );
};

export const Logo = ({ width = "100", height = "100" }: any) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 196 198"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="sm:w-[100px] sm:h-[100px] w-[50px] h-[50px]"
    >
      <path
        d="M192.658 97.9398C192.658 150.37 150.248 192.873 97.9336 192.873C45.6191 192.873 3.20899 150.37 3.20899 97.9398C3.20899 45.51 45.6191 3.00652 97.9336 3.00652C150.248 3.00652 192.658 45.51 192.658 97.9398ZM165.02 165.174C182.939 147.216 192.808 123.338 192.808 97.9398C192.808 72.542 182.939 48.6653 165.02 30.7052C147.102 12.747 123.276 2.85609 97.9336 2.85609C72.5917 2.85609 48.7674 12.747 30.8468 30.7052C12.9281 48.6634 3.0589 72.542 3.0589 97.9398C3.0589 123.338 12.9281 147.216 30.8468 165.174C48.7655 183.133 72.5917 193.023 97.9336 193.023C123.276 193.023 147.102 183.133 165.02 165.174ZM192.51 97.9398C192.51 150.204 150.083 192.725 97.9336 192.725C45.784 192.725 3.35723 150.204 3.35723 97.9398C3.35723 45.6753 45.784 3.15509 97.9336 3.15509C150.083 3.15509 192.51 45.6753 192.51 97.9398Z"
        stroke="url(#paint0_linear_10_3)"
        strokeWidth="3"
        strokeMiterlimit="10"
      />
      <path
        d="M97.9337 161.128C132.755 161.128 160.983 132.838 160.983 97.9398C160.983 63.042 132.755 34.7518 97.9337 34.7518C63.1126 34.7518 34.8846 63.042 34.8846 97.9398C34.8846 132.838 63.1126 161.128 97.9337 161.128Z"
        stroke="url(#paint1_linear_10_3)"
        strokeWidth="3"
        strokeMiterlimit="10"
      />
      <path
        d="M41.0644 58.4448L26.8295 47.5751L22.94 52.6914L19.8455 50.3292L30.3595 36.4994L33.4541 38.8616L29.546 44.0021L43.7809 54.8717L41.0644 58.4448ZM40.9921 57.4401L42.7933 55.0704L28.5584 44.2008L32.4479 39.0845L30.4484 37.5579L20.8665 50.1602L22.8659 51.6868L26.7554 46.5704L40.9903 57.4401H40.9921Z"
        fill="url(#paint2_linear_10_3)"
      />
      <path
        d="M48.6488 48.7785L35.509 31.3626L39.1187 28.6271L44.0163 35.1177L50.563 30.1574L45.6654 23.6668L49.264 20.9406L62.4019 38.3565L58.8034 41.0827L52.9793 33.3627L46.4326 38.3249L52.2566 46.0449L48.647 48.7804L48.6488 48.7785ZM48.8434 47.7571L51.2264 45.952L45.4023 38.232L53.1646 32.3506L58.9887 40.0706L61.3828 38.2562L49.0917 21.9638L46.6976 23.7782L51.5859 30.2576L43.8235 36.1391L38.9353 29.6597L36.5523 31.4648L48.8434 47.7571Z"
        fill="url(#paint3_linear_10_3)"
      />
      <path
        d="M65.1704 36.9692L57.3673 16.5856L72.1285 10.9103L73.4849 14.4537L62.8523 18.5412L64.5163 22.8868L74.2372 19.1484L75.5733 22.6361L65.8523 26.3744L67.861 31.6189L79.031 27.3234L80.4726 31.0878L65.1741 36.9711L65.1704 36.9692ZM65.6262 36.0481L79.4757 30.7219L78.5325 28.2594L67.3903 32.5437L64.8943 26.0253L74.6301 22.2814L73.7814 20.0677L64.0475 23.8116L61.885 18.166L72.4898 14.0878L71.6374 11.8593L58.3272 16.9775L65.6281 36.0462L65.6262 36.0481Z"
        fill="url(#paint4_linear_10_3)"
      />
      <path
        d="M90.3196 29.6039L90.4826 7.77184L105.729 7.88512L105.702 11.6792L94.8762 11.5975L94.8391 16.5485L104.319 16.6191L104.291 20.4131L94.8113 20.3426L94.7427 29.6355L90.3214 29.6021L90.3196 29.6039ZM91.0941 28.9131L93.9923 28.9354L94.0608 19.6424L103.511 19.713L103.53 17.3118L94.0794 17.2412L94.1257 10.8973L104.907 10.9791L104.925 8.59267L91.2442 8.49053L91.0923 28.915L91.0941 28.9131Z"
        fill="url(#paint5_linear_10_3)"
      />
      <path
        d="M107.382 30.4396L111.433 8.98824L115.836 9.82393L111.785 31.2753L107.382 30.4396ZM108.253 29.8955L111.173 30.4489L114.963 10.3811L112.043 9.82765L108.253 29.8974V29.8955Z"
        fill="url(#paint6_linear_10_3)"
      />
      <path
        d="M114.881 31.526L123.111 11.3115L131.888 14.9013C133.577 15.5921 134.787 16.2254 135.517 16.8011C136.247 17.3768 136.793 18.0658 137.16 18.8662C137.481 19.5942 137.631 20.3667 137.609 21.1783C137.586 21.9917 137.392 22.8497 137.023 23.7559C136.517 25.0002 135.841 25.9009 134.996 26.4562C134.151 27.0133 133.104 27.2436 131.855 27.1489C132.702 27.7617 133.2 28.486 133.35 29.3217C133.501 30.1574 133.317 31.2735 132.8 32.6737L131.918 35.114C131.9 35.1604 131.874 35.2235 131.84 35.3053C131.401 36.4604 131.379 37.2626 131.772 37.7102L131.52 38.3286L126.974 36.4697C126.95 36.1075 126.978 35.7212 127.056 35.3108C127.134 34.9004 127.289 34.3786 127.525 33.749L128.342 31.5855C128.811 30.3041 128.92 29.3588 128.673 28.7515C128.425 28.1443 127.749 27.6131 126.644 27.1619L122.249 25.3642L119.047 33.2272L114.885 31.5242L114.881 31.526ZM115.856 31.1732L118.595 32.293L121.786 24.4561L126.702 26.4654C128.053 27.017 128.92 27.6614 129.303 28.3931C129.687 29.1267 129.663 30.0719 129.235 31.2308L128.446 33.4054C128.421 33.4909 128.379 33.6079 128.32 33.7546C127.934 34.7816 127.751 35.5448 127.771 36.0444L130.879 37.3146C130.747 37.0361 130.691 36.7389 130.715 36.4232C130.738 36.1057 130.893 35.569 131.179 34.8113L132.074 32.3766C132.567 31.0618 132.709 29.9977 132.504 29.1824C132.298 28.3671 131.664 27.5073 130.606 26.6047C132.122 26.7013 133.323 26.51 134.21 26.029C135.098 25.5499 135.78 24.7235 136.256 23.5516C136.997 21.7317 137.04 20.2014 136.384 18.9609C135.728 17.7222 134.309 16.6562 132.127 15.763L123.555 12.2567L115.856 31.1676V31.1732ZM122.701 22.2052L125.394 15.5902L131.09 17.919C132.257 18.3963 133.041 19.05 133.438 19.8801C133.834 20.7103 133.819 21.65 133.391 22.7029C132.952 23.7819 132.305 24.4783 131.455 24.7922C130.602 25.106 129.583 25.0188 128.397 24.5341L122.701 22.2052ZM123.676 21.8505L128.605 23.8655C129.619 24.2796 130.462 24.3688 131.132 24.1311C131.805 23.8934 132.324 23.3214 132.693 22.4151C133.054 21.5274 133.074 20.7567 132.756 20.103C132.435 19.4493 131.779 18.92 130.784 18.5133L125.855 16.4965L123.676 21.8487V21.8505Z"
        fill="url(#paint7_linear_10_3)"
      />
      <path
        d="M136.671 33.6821L140.168 36.4436C139.575 37.4353 139.406 38.4159 139.662 39.3853C139.918 40.3547 140.57 41.2535 141.624 42.0874C142.716 42.9491 143.692 43.4171 144.554 43.4858C145.416 43.5564 146.133 43.2258 146.707 42.4978C147.165 41.9147 147.283 41.2795 147.061 40.5868C146.839 39.896 145.87 38.4939 144.154 36.3824C142.304 34.1037 141.296 32.2912 141.126 30.941C140.955 29.5928 141.439 28.1963 142.575 26.7533C143.868 25.1079 145.423 24.2778 147.235 24.2648C149.047 24.2499 150.976 25.0503 153.02 26.666C155.111 28.317 156.363 30.0775 156.776 31.9457C157.19 33.814 156.73 35.6432 155.398 37.4335L152.005 34.7333C152.607 33.8883 152.794 33.0043 152.566 32.0813C152.338 31.1583 151.712 30.2929 150.691 29.4851C149.731 28.7274 148.862 28.3225 148.084 28.2743C147.306 28.226 146.651 28.5398 146.12 29.2139C145.375 30.1611 145.871 31.6913 147.61 33.8084C148.021 34.3228 148.345 34.724 148.584 35.0118C150.535 37.5096 151.608 39.4336 151.803 40.7837C151.997 42.132 151.536 43.5174 150.419 44.938C149.051 46.6763 147.378 47.5528 145.401 47.5696C143.424 47.5863 141.346 46.7339 139.171 45.016C137.018 43.3149 135.724 41.4764 135.292 39.4967C134.859 37.5189 135.32 35.5801 136.675 33.6803L136.671 33.6821ZM136.897 34.711C135.926 36.4232 135.674 38.1132 136.137 39.7827C136.601 41.4504 137.763 43.0197 139.621 44.4886C141.611 46.0616 143.494 46.8434 145.269 46.8379C147.044 46.8323 148.549 46.0449 149.781 44.4775C150.776 43.2128 151.191 41.9797 151.025 40.7781C150.858 39.5766 149.815 37.7455 147.897 35.2867C147.724 35.075 147.469 34.7537 147.13 34.3228C145.119 31.8027 144.584 29.9456 145.525 28.7515C146.172 27.9288 146.976 27.5333 147.937 27.563C148.899 27.5927 149.937 28.0495 151.052 28.9298C152.159 29.8045 152.876 30.7331 153.204 31.7155C153.53 32.696 153.447 33.6784 152.952 34.659L155.159 36.4028C156.113 34.854 156.367 33.2866 155.92 31.7006C155.474 30.1146 154.364 28.6197 152.59 27.2194C150.717 25.7393 148.977 25.002 147.37 25.0095C145.764 25.0169 144.374 25.7653 143.201 27.2566C142.193 28.5361 141.739 29.7284 141.839 30.8315C141.937 31.9346 142.836 33.554 144.533 35.6878C144.567 35.7268 144.615 35.79 144.682 35.881C147.433 39.3259 148.306 41.6881 147.298 42.9695C146.614 43.8386 145.734 44.2435 144.656 44.1841C143.577 44.1246 142.415 43.6046 141.17 42.6185C140.055 41.7383 139.33 40.7763 138.993 39.7363C138.656 38.6963 138.728 37.6303 139.21 36.5384L136.899 34.7128L136.897 34.711Z"
        fill="url(#paint8_linear_10_3)"
      />
      <path
        d="M150.534 55.44L164.874 44.7115L161.035 39.5562L164.151 37.2236L174.528 51.1575L171.412 53.49L167.554 48.3105L153.213 59.039L150.532 55.44H150.534ZM151.517 55.648L153.296 58.0362L167.637 47.3077L171.476 52.463L173.491 50.9551L164.033 38.258L162.019 39.766L165.858 44.9213L151.517 55.6498V55.648Z"
        fill="url(#paint9_linear_10_3)"
      />
      <path
        d="M57.3747 140.295L59.476 142.252L136.901 59.702L138.22 58.2999L136.945 57.2581L135.65 58.6063L57.3747 140.295Z"
        fill="#423C38"
      />
      <path
        d="M59.476 142.252C58.2938 142.23 57.3543 141.353 57.3728 140.293L59.476 142.252Z"
        fill="#2B2725"
      />
      <path
        d="M92.9231 105.067L84.2176 115.985L59.476 142.252L57.3747 140.295L70.0457 127.102L82.1589 114.49L92.9231 105.067Z"
        fill="url(#paint10_linear_10_3)"
      />
      <path
        d="M138.22 58.2999C138.231 57.7372 137.661 57.2711 136.945 57.2581L138.22 58.2999Z"
        fill="#4378BB"
      />
      <path
        d="M138.22 58.2999L136.795 59.8135L135.528 58.7363L136.945 57.2581L138.22 58.2999Z"
        fill="#BFBEBE"
      />
      <path
        d="M136.106 58.1328L137.351 59.2247"
        stroke="#D0D2D3"
        strokeWidth="0.25"
        strokeMiterlimit="10"
      />
      <path
        d="M138.246 140.269L140.201 138.161L57.8324 60.5656L56.4334 59.2433L55.3938 60.521L56.7391 61.8191L138.246 140.269Z"
        fill="#423C38"
      />
      <path
        d="M140.201 138.161C140.179 139.346 139.304 140.287 138.246 140.269L140.201 138.161Z"
        fill="#2B2725"
      />
      <path
        d="M103.098 104.642L113.992 113.365L140.201 138.161L138.246 140.269L125.082 127.568L112.5 115.428L103.098 104.642Z"
        fill="url(#paint11_linear_10_3)"
      />
      <path
        d="M56.4334 59.2433C55.8719 59.2322 55.4068 59.8042 55.3938 60.521L56.4334 59.2433Z"
        fill="#4378BB"
      />
      <path
        d="M56.4334 59.2433L57.9436 60.6714L56.867 61.9435L55.3938 60.521L56.4334 59.2433Z"
        fill="#BFBEBE"
      />
      <path
        d="M56.2666 61.3623L57.3562 60.1143"
        stroke="#D0D2D3"
        strokeWidth="0.25"
        strokeMiterlimit="10"
      />
      <path
        d="M174.026 90.9162C174.137 91.0982 174.23 91.2932 174.278 91.5105C174.469 92.3462 174.145 93.2228 174.217 94.077C174.363 95.8023 175.479 97.3567 176.583 98.6176C177.719 99.9158 179.07 101.104 179.806 102.7C180.434 104.063 180.449 105.593 180.499 107.084C179.674 107.19 178.761 106.939 177.847 106.399C177.76 106.347 177.673 106.293 177.586 106.235C175.99 105.194 174.415 103.283 173.322 100.844C172.299 98.5601 171.897 96.2684 172.08 94.4354C172.249 92.7566 172.905 91.4641 174.026 90.9181V90.9162Z"
        fill="url(#paint12_linear_10_3)"
      />
      <path
        d="M182.046 96.911C182.898 98.8108 183.321 100.718 183.33 102.36C183.343 104.161 182.861 105.645 181.914 106.455C181.877 105.467 181.831 104.475 181.605 103.511C181.259 102.035 180.451 100.77 179.467 99.6316C178.52 98.5396 177.452 97.5442 176.644 96.339C176.266 95.7726 175.913 95.1393 175.751 94.4763C175.579 93.7687 175.711 93.141 175.762 92.4316C175.809 91.7593 175.699 91.1762 175.47 90.6507C176.259 90.7064 177.104 91.0481 177.938 91.6256C179.48 92.6879 180.986 94.5561 182.044 96.9128L182.046 96.911Z"
        fill="url(#paint13_linear_10_3)"
      />
      <path
        d="M175.755 104.551C175.883 104.662 175.987 104.768 176.07 104.867C174.475 103.825 173.806 102.046 172.825 99.5982C171.445 96.1495 172.131 93.4902 172.403 92.92C172.403 92.92 173.038 102.137 175.755 104.551Z"
        fill="url(#paint14_linear_10_3)"
      />
      <path
        d="M182.046 96.911C182.898 98.8108 183.321 100.718 183.33 102.36C183.312 102.308 183.299 102.237 183.289 102.142C183.095 100.042 177.932 91.6387 177.932 91.6387L177.94 91.6238C179.481 92.6861 180.988 94.5543 182.046 96.911Z"
        fill="url(#paint15_linear_10_3)"
      />
      <path
        d="M22.0487 90.9404C21.9986 91.1484 21.9264 91.3508 21.8078 91.5384C21.3538 92.2645 20.5051 92.6545 19.9548 93.31C18.8411 94.6341 18.5335 96.5228 18.4242 98.1979C18.3111 99.9213 18.4279 101.719 17.8238 103.368C17.3068 104.778 16.2376 105.87 15.2203 106.96C14.5625 106.449 14.0937 105.626 13.8287 104.596C13.8027 104.497 13.7805 104.397 13.7583 104.295C13.3654 102.428 13.6008 99.9603 14.5476 97.4607C15.4352 95.1207 16.7676 93.2153 18.1907 92.0491C19.4934 90.9812 20.8702 90.5318 22.0487 90.9404Z"
        fill="url(#paint16_linear_10_3)"
      />
      <path
        d="M23.4904 100.863C22.7528 102.811 21.7059 104.458 20.5533 105.626C19.2914 106.91 17.9035 107.617 16.6638 107.519C17.3346 106.794 18.0017 106.061 18.5224 105.218C19.3192 103.927 19.6398 102.462 19.7472 100.959C19.8492 99.5165 19.7954 98.0568 20.0752 96.6305C20.2068 95.962 20.4032 95.2637 20.759 94.6806C21.137 94.0584 21.6725 93.7075 22.2099 93.2432C22.7176 92.8012 23.0512 92.3109 23.2587 91.7761C23.7776 92.3759 24.1352 93.2153 24.3168 94.2144C24.6578 96.0585 24.4057 98.4468 23.4904 100.863Z"
        fill="url(#paint17_linear_10_3)"
      />
      <path
        d="M13.7583 103.849C13.7694 104.018 13.7694 104.167 13.7583 104.295C13.3654 102.428 13.6008 99.9603 14.5476 97.4607C15.4352 95.1207 16.7676 93.2153 18.1907 92.0491C18.1907 92.0491 13.5396 100.217 13.7583 103.849Z"
        fill="url(#paint18_linear_10_3)"
      />
      <path
        d="M23.4903 100.863C22.7528 102.811 21.7059 104.458 20.5533 105.626C20.5774 105.576 20.6181 105.517 20.6774 105.444C22.0227 103.821 24.3001 94.22 24.3001 94.22L24.3168 94.2144C24.6577 96.0586 24.4057 98.4468 23.4903 100.863Z"
        fill="url(#paint19_linear_10_3)"
      />
      <path
        d="M104.873 74.0704L105.931 73.8253C106.635 73.6619 107.39 73.3072 108.112 72.8002C108.959 72.2059 109.654 71.4723 110.067 70.7332C110.488 69.9829 110.568 69.3107 110.293 68.8427C109.923 68.215 108.959 68.0218 107.755 68.3951L107.523 68.4675L107.469 68.6848C107.054 70.3488 106.376 71.8772 105.451 73.2273L104.873 74.0723V74.0704ZM108.266 69.0878C108.892 68.9337 109.391 69.0005 109.521 69.2215C109.617 69.3868 109.615 69.7861 109.287 70.3711C108.931 71.0062 108.324 71.6432 107.577 72.1688C107.314 72.3545 107.065 72.503 106.836 72.6219C107.453 71.5299 107.933 70.3469 108.264 69.0878H108.266Z"
        fill="url(#paint20_linear_10_3)"
      />
      <path
        d="M88.8909 75.0881C91.0867 77.5024 93.9589 78.8321 96.9756 78.8321C99.9924 78.8321 102.624 77.6082 104.782 75.3816C104.945 75.389 105.105 75.3871 105.272 75.376C106.408 75.2998 107.669 74.8133 108.824 74.0036C111.351 72.2301 112.519 69.6357 111.539 67.9699C111.02 67.0896 109.984 66.6513 108.702 66.7497C108.728 66.5157 108.748 66.2817 108.765 66.0496C108.792 65.6318 108.639 65.2269 108.342 64.9372C108.088 64.6902 107.755 64.5546 107.404 64.5546H86.5505C86.2003 64.5546 85.8686 64.6902 85.6129 64.9372C85.3146 65.2269 85.1589 65.6318 85.1867 66.0515C85.4165 69.5057 86.7321 72.7166 88.8928 75.09L88.8909 75.0881ZM86.2503 65.4832C86.3115 65.4238 86.4134 65.3532 86.5487 65.3532H107.403C107.538 65.3532 107.64 65.4238 107.703 65.4851C107.832 65.6113 107.903 65.8045 107.89 65.9995C107.864 66.3858 107.821 66.7795 107.766 67.1694L107.686 67.7284L108.292 67.6114C109.458 67.3867 110.358 67.656 110.766 68.3469C111.52 69.6301 110.41 71.8828 108.288 73.3703C107.269 74.0853 106.174 74.5143 105.207 74.5793C105.014 74.5923 104.834 74.5904 104.645 74.5719L104.414 74.5477L104.264 74.7093C102.255 76.8542 99.6662 78.0335 96.9756 78.0335C91.3035 78.0335 86.5098 72.7482 86.0613 66.0013C86.0484 65.8045 86.1188 65.6095 86.2503 65.4832Z"
        fill="url(#paint21_linear_10_3)"
      />
      <path
        d="M98.2802 54.8624C98.0949 55.0723 97.9059 55.2617 97.6705 55.4493C97.4352 55.6461 97.1776 55.8485 96.9089 56.0584C96.3827 56.4837 95.7953 56.9684 95.3542 57.6369C94.9077 58.2999 94.7112 59.1505 94.8335 59.8952C94.941 60.651 95.2894 61.3177 95.7434 61.8693C96.2066 62.4171 96.7681 62.8758 97.4148 63.1785C96.6439 62.0828 96.1418 60.8924 96.2122 59.8339C96.2493 59.3065 96.429 58.8589 96.7533 58.4578C97.0757 58.0511 97.5427 57.6703 98.0652 57.2581C99.0733 56.4818 100.493 55.232 100.313 53.4863C100.257 53.0629 100.063 52.6413 99.7663 52.3312C99.4735 52.0173 99.1214 51.8056 98.7842 51.6515C98.0986 51.3469 97.4593 51.1983 96.8385 50.8548C97.1795 51.4528 97.8336 51.8632 98.2913 52.2903C98.7768 52.7137 98.9954 53.1334 98.9417 53.5569C98.9046 53.9803 98.6434 54.4483 98.282 54.8624H98.2802Z"
        fill="url(#paint22_linear_10_3)"
      />
      <path
        d="M93.5809 62.2945C93.0046 61.587 92.584 60.8126 92.4783 60.027C92.3727 59.2415 92.6396 58.493 93.2029 57.9192C93.7847 57.3268 94.5797 56.7492 95.1393 55.973C95.4172 55.5885 95.6637 55.1298 95.6526 54.6191C95.6285 54.101 95.269 53.6869 94.8632 53.4584C95.1448 53.8224 95.3135 54.2273 95.2245 54.5968C95.1467 54.9664 94.8836 55.2914 94.5963 55.5978C93.996 56.2144 93.2529 56.7065 92.5432 57.3936C92.2004 57.7651 91.9243 58.207 91.7909 58.6918C91.6686 59.1746 91.663 59.6834 91.8075 60.144C92.0762 61.0744 92.7563 61.8303 93.5809 62.2927V62.2945Z"
        fill="url(#paint23_linear_10_3)"
      />
      <path
        d="M99.1288 58.4912C98.8676 58.8533 98.6934 59.2786 98.6508 59.7113C98.6137 60.144 98.673 60.5767 98.8379 60.963C99.1529 61.7393 99.7589 62.367 100.491 62.757C100.011 62.1255 99.644 61.4663 99.4957 60.7921C99.3456 60.118 99.4698 59.4643 99.8589 58.9313C100.25 58.3983 100.913 57.9285 101.484 57.3398C101.771 57.0464 102.036 56.7047 102.188 56.3109C102.336 55.9172 102.338 55.4845 102.183 55.1243C102.129 55.9191 101.614 56.4428 101.006 56.8959C100.404 57.3621 99.6755 57.7688 99.1288 58.4893V58.4912Z"
        fill="url(#paint24_linear_10_3)"
      />
      <path
        d="M104.473 129.797C104.473 132.976 101.901 135.552 98.7286 135.552C95.5562 135.552 92.9861 132.974 92.9861 129.797C92.9861 126.619 95.5581 124.041 98.7286 124.041C101.899 124.041 104.473 126.617 104.473 129.797Z"
        stroke="url(#paint25_linear_10_3)"
        strokeMiterlimit="10"
      />
      <path
        d="M98.9083 134.93C95.9843 134.93 93.6124 132.552 93.6124 129.622C93.6124 128.186 94.1831 126.886 95.1078 125.932C94.0794 126.899 93.4345 128.27 93.4345 129.797C93.4345 132.729 95.8064 135.104 98.7304 135.104C100.222 135.104 101.569 134.484 102.531 133.488C101.584 134.382 100.313 134.931 98.9102 134.931L98.9083 134.93Z"
        fill="#414042"
        stroke="url(#paint26_linear_10_3)"
        strokeMiterlimit="10"
      />
      <path
        d="M96.4938 131.089C96.4938 130.274 96.9812 129.691 97.7743 129.338V129.297C97.0497 128.966 96.7292 128.404 96.7273 127.841C96.7236 126.818 97.6056 126.101 98.749 126.097C100.013 126.095 100.646 126.888 100.648 127.702C100.648 128.253 100.381 128.848 99.5791 129.232V129.26C100.393 129.57 100.897 130.162 100.897 130.948C100.9 132.094 99.9293 132.85 98.6748 132.851C97.3203 132.853 96.4975 132.044 96.4938 131.089ZM100.003 131.041C100.003 130.257 99.4494 129.865 98.5655 129.626C97.8039 129.839 97.3944 130.354 97.3963 130.976C97.3685 131.631 97.8706 132.213 98.7045 132.211C99.4957 132.207 100.005 131.715 100.003 131.043V131.041ZM97.5686 127.78C97.5593 128.435 98.0615 128.784 98.8157 128.983C99.3771 128.79 99.7959 128.387 99.7959 127.795C99.7959 127.273 99.4939 126.73 98.6897 126.734C97.967 126.734 97.5667 127.219 97.5686 127.78Z"
        fill="#414042"
        stroke="url(#paint27_linear_10_3)"
        strokeMiterlimit="10"
      />
      <path
        d="M111.668 130.642C111.668 137.96 105.75 143.894 98.447 143.894C91.1442 143.894 85.2256 137.96 85.2256 130.642C85.2256 123.323 91.146 117.393 98.447 117.393C105.748 117.393 111.668 123.325 111.668 130.642Z"
        stroke="url(#paint28_linear_10_3)"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M98.447 144.575C90.781 144.575 84.5456 138.324 84.5456 130.642C84.5456 122.959 90.781 116.71 98.447 116.71C106.113 116.71 112.348 122.961 112.348 130.642C112.348 138.323 106.113 144.575 98.447 144.575ZM98.447 118.075C91.5333 118.075 85.9076 123.715 85.9076 130.642C85.9076 137.569 91.5352 143.21 98.447 143.21C105.359 143.21 110.988 137.572 110.988 130.642C110.988 123.711 105.361 118.075 98.447 118.075Z"
        stroke="url(#paint29_linear_10_3)"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M108.388 126.372C108.755 127.466 108.965 128.636 108.965 129.856C108.965 135.89 104.084 140.783 98.0597 140.783C93.6476 140.783 89.8564 138.15 88.1386 134.374C89.5914 138.701 93.6643 141.819 98.4674 141.819C104.49 141.819 109.372 136.926 109.372 130.892C109.372 129.278 109.015 127.75 108.388 126.372Z"
        stroke="url(#paint30_linear_10_3)"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M88.1238 130.926C87.1491 127.119 89.1634 122.91 92.8787 121.475C93.0343 122 93.19 122.53 93.3456 123.057C93.4383 123.377 92.9083 123.38 92.6526 123.507C92.017 123.819 91.4574 124.244 90.9423 124.729C90.0472 125.652 89.269 126.768 88.8613 127.999C88.6519 128.632 88.5092 129.265 88.3981 129.925C88.3351 130.237 88.4944 130.9 88.1238 130.926Z"
        stroke="url(#paint31_linear_10_3)"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M96.5643 121.332C96.7329 121.904 96.4068 122.506 95.8361 122.675C95.2653 122.844 94.6668 122.517 94.4963 121.945C94.3277 121.373 94.6538 120.773 95.2246 120.602C95.7953 120.433 96.3938 120.76 96.5643 121.332Z"
        stroke="url(#paint32_linear_10_3)"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M70.3051 99.1841H70.0754C70.0976 99.0355 70.1106 98.9185 70.1106 98.8312C70.1106 98.7161 70.0624 98.6381 69.9642 98.6028C69.8678 98.5656 69.5009 98.5489 68.8672 98.5489L68.2316 98.5526L67.7535 100.473H68.6504C68.9339 100.473 69.1081 100.452 69.1729 100.41C69.2378 100.367 69.2841 100.263 69.3138 100.094H69.5621C69.4694 100.445 69.386 100.831 69.3138 101.251H69.0914C69.1062 101.115 69.1136 101.01 69.1136 100.933C69.1136 100.902 69.0933 100.863 69.0525 100.816C69.0321 100.794 68.995 100.777 68.9395 100.768C68.8616 100.753 68.7393 100.746 68.5744 100.746H67.6831C67.4255 101.732 67.1587 102.503 66.8826 103.064C67.1513 102.978 67.3903 102.935 67.5997 102.935C67.9481 102.935 68.3724 102.991 68.8783 103.101C69.1451 103.162 69.3267 103.192 69.4212 103.192C69.5491 103.192 69.651 103.16 69.7307 103.097C69.8085 103.034 69.8474 102.961 69.8474 102.88C69.8474 102.833 69.8271 102.759 69.7881 102.655C69.7641 102.583 69.7511 102.516 69.7511 102.451C69.7511 102.386 69.777 102.324 69.8308 102.272C69.8845 102.22 69.9493 102.194 70.0235 102.194C70.1124 102.194 70.1884 102.23 70.2477 102.298C70.307 102.367 70.3366 102.462 70.3366 102.577C70.3366 102.824 70.2292 103.039 70.0124 103.225C69.7955 103.411 69.512 103.504 69.1581 103.504C68.9728 103.504 68.7375 103.487 68.454 103.455C67.8313 103.385 67.3551 103.351 67.029 103.351C66.6009 103.351 66.0988 103.387 65.5243 103.455L65.5929 103.212C65.9357 103.117 66.1395 103.047 66.2007 103.002C66.2618 102.958 66.3119 102.893 66.3545 102.805C66.4935 102.531 66.6732 101.977 66.8937 101.149C67.1142 100.321 67.3403 99.4441 67.5682 98.5229C67.2198 98.5229 66.8919 98.6046 66.5806 98.7699C66.2711 98.9352 66.0284 99.1506 65.8542 99.4162C65.68 99.6818 65.5929 99.9603 65.5929 100.252C65.5929 100.376 65.6059 100.486 65.63 100.577C65.6541 100.67 65.7096 100.8 65.7967 100.969C65.8523 101.071 65.8801 101.153 65.8801 101.216C65.8801 101.279 65.8542 101.336 65.8004 101.385C65.7467 101.433 65.6818 101.459 65.604 101.459C65.491 101.459 65.402 101.403 65.3372 101.29C65.239 101.125 65.1908 100.9 65.1908 100.616C65.1908 100.007 65.4206 99.4589 65.882 98.9742C66.3434 98.4895 67.0123 98.2481 67.8925 98.2481H69.3823C69.8975 98.2481 70.2792 98.2147 70.5238 98.1478C70.4089 98.6306 70.3348 98.9761 70.3014 99.1785L70.3051 99.1841Z"
        fill="url(#paint33_linear_10_3)"
      />
      <path
        d="M74.5912 99.8192H74.3651C74.3966 99.5146 74.4133 99.2843 74.4133 99.1265C74.4133 98.9036 74.354 98.7272 74.2335 98.5972C74.1131 98.4672 73.9519 98.4041 73.7462 98.4041C73.4293 98.4041 73.1514 98.5192 72.9142 98.7495C72.677 98.9798 72.5584 99.2398 72.5584 99.5276C72.5584 99.6818 72.5899 99.821 72.6566 99.9455C72.7215 100.07 72.866 100.244 73.0884 100.467C73.496 100.868 73.7629 101.182 73.8889 101.409C74.0149 101.635 74.0797 101.856 74.0797 102.072C74.0797 102.388 73.9834 102.694 73.7907 102.987C73.598 103.281 73.3144 103.522 72.9401 103.714C72.5658 103.903 72.1693 104 71.7523 104C71.3354 104 70.9945 103.892 70.7128 103.678C70.4311 103.465 70.2885 103.236 70.2885 102.999C70.2885 102.87 70.3255 102.765 70.3996 102.681C70.4738 102.597 70.559 102.555 70.6535 102.555C70.748 102.555 70.8332 102.594 70.8962 102.672C70.937 102.718 70.9778 102.822 71.0185 102.986C71.0649 103.182 71.1205 103.325 71.1872 103.415C71.2539 103.504 71.3465 103.576 71.4633 103.632C71.58 103.688 71.7079 103.717 71.8469 103.717C72.2601 103.717 72.6233 103.578 72.9327 103.298C73.2422 103.017 73.3978 102.707 73.3978 102.367C73.3978 102.252 73.3774 102.135 73.3385 102.022C73.2996 101.908 73.2274 101.777 73.1236 101.632C73.0513 101.533 72.8901 101.359 72.6418 101.11C72.3953 100.867 72.2415 100.699 72.1767 100.608C72.0877 100.478 72.021 100.347 71.9766 100.215C71.9339 100.083 71.9117 99.951 71.9117 99.821C71.9117 99.5573 72.0006 99.2918 72.1767 99.0243C72.3527 98.7569 72.5825 98.5452 72.8642 98.3855C73.1458 98.2277 73.4664 98.1478 73.8259 98.1478C74.0056 98.1478 74.2261 98.1757 74.4911 98.2314C74.6412 98.2611 74.7728 98.2815 74.8821 98.2964C74.8191 98.4858 74.7691 98.6622 74.7339 98.8294C74.6987 98.9965 74.6505 99.3271 74.5912 99.8248V99.8192Z"
        fill="url(#paint34_linear_10_3)"
      />
      <path
        d="M78.5177 103.106L78.4566 103.355C78.2564 103.398 78.0934 103.42 77.9655 103.42C77.8377 103.42 77.6431 103.407 77.3614 103.381C77.1502 103.364 76.9612 103.355 76.7926 103.355C76.5035 103.355 76.2051 103.381 75.8975 103.433L75.9587 103.194C76.2515 103.164 76.4646 103.104 76.598 103.012C76.6943 102.945 76.7759 102.831 76.8426 102.67C76.9093 102.508 77.0649 101.947 77.3058 100.984L77.8617 98.6771L77.8914 98.5675C77.7209 98.5582 77.5912 98.5545 77.5041 98.5545C76.9686 98.5545 76.5442 98.6121 76.2292 98.7291C75.9142 98.8461 75.6789 99.0132 75.5214 99.2342C75.3639 99.4552 75.2842 99.6929 75.2842 99.9492C75.2842 100.04 75.3009 100.122 75.3324 100.198C75.3546 100.25 75.4195 100.335 75.5232 100.451C75.6214 100.558 75.6715 100.657 75.6715 100.748C75.6715 100.826 75.6418 100.893 75.5844 100.948C75.5269 101.004 75.4565 101.032 75.3768 101.032C75.2545 101.032 75.1563 100.974 75.0822 100.857C74.9729 100.686 74.9173 100.469 74.9173 100.204C74.9173 99.8489 75.0266 99.5053 75.2453 99.1729C75.4639 98.8405 75.7641 98.5805 76.1459 98.3985C76.5276 98.2165 76.9927 98.1237 77.5393 98.1237C77.8006 98.1237 78.2157 98.1608 78.7864 98.2369C79.1922 98.2889 79.485 98.3149 79.6684 98.3149C79.8519 98.3149 79.9797 98.2852 80.0557 98.2239C80.1317 98.1626 80.1688 98.0809 80.1688 97.9807C80.1688 97.9602 80.165 97.9194 80.1558 97.8581C80.1465 97.8024 80.1428 97.7671 80.1428 97.7485C80.1428 97.6705 80.1688 97.6055 80.2206 97.5535C80.2725 97.5015 80.3355 97.4755 80.4078 97.4755C80.4949 97.4755 80.5672 97.5071 80.6227 97.5721C80.6783 97.6371 80.708 97.7207 80.708 97.8284C80.708 98.0494 80.5912 98.2388 80.3559 98.3985C80.1224 98.5582 79.7296 98.6381 79.1811 98.6381C78.9847 98.6381 78.7753 98.6288 78.5529 98.6121C78.5233 98.7161 78.4325 99.0708 78.2787 99.6743L77.9007 101.18L77.6709 102.1L77.4318 103.149C77.6264 103.171 77.7858 103.184 77.9136 103.184C78.1082 103.184 78.3102 103.16 78.5214 103.11L78.5177 103.106Z"
        fill="url(#paint35_linear_10_3)"
      />
      <path
        d="M81.4862 99.1674L81.5289 98.9798C81.8439 98.9538 82.2163 98.8907 82.6444 98.7885C82.5202 99.1098 82.4091 99.4756 82.3145 99.8861L82.0273 101.101C81.8216 101.977 81.59 102.638 81.3324 103.086C81.5808 103.136 81.8013 103.16 81.9921 103.16C82.498 103.16 82.939 103.054 83.3152 102.841C83.6913 102.627 83.9897 102.317 84.2102 101.907C84.4307 101.498 84.5419 101.047 84.5419 100.553C84.5419 99.9065 84.3547 99.3846 83.9786 98.9928C83.6024 98.5991 83.1114 98.4022 82.5036 98.4022C81.9921 98.4022 81.5085 98.5248 81.0545 98.7681C80.6005 99.0114 80.241 99.3345 79.976 99.7356C79.7111 100.137 79.5795 100.529 79.5795 100.909C79.5795 101.29 79.7425 101.554 80.065 101.728C80.1576 101.78 80.2169 101.825 80.2447 101.864C80.2725 101.903 80.2855 101.947 80.2855 102.003C80.2855 102.074 80.2577 102.135 80.204 102.189C80.1502 102.243 80.0891 102.269 80.0186 102.269C79.8648 102.269 79.7148 102.167 79.5702 101.964C79.3719 101.68 79.2737 101.388 79.2737 101.089C79.2737 100.59 79.422 100.107 79.7185 99.6428C80.0149 99.1785 80.4282 98.8071 80.9581 98.5304C81.4881 98.2537 82.0774 98.1162 82.7259 98.1162C83.5246 98.1162 84.162 98.3298 84.6345 98.7588C85.1071 99.1878 85.3442 99.7245 85.3442 100.371C85.3442 100.971 85.1793 101.524 84.8495 102.027C84.5196 102.531 84.1212 102.889 83.6543 103.103C83.1873 103.316 82.7204 103.422 82.2552 103.422C82.1052 103.422 81.8439 103.407 81.4733 103.379C81.1601 103.357 80.8636 103.344 80.5838 103.344C80.4541 103.344 80.2558 103.348 79.989 103.357L80.0891 103.143C80.3559 103.129 80.5208 103.106 80.5857 103.073C80.6505 103.041 80.7061 102.987 80.7525 102.911C80.8358 102.778 80.9507 102.488 81.0953 102.04L81.3954 100.904L81.742 99.4849C81.7586 99.4144 81.7679 99.3549 81.7679 99.3066C81.7679 99.2602 81.7531 99.2231 81.7253 99.1952C81.6956 99.1674 81.6549 99.1544 81.603 99.1544C81.5826 99.1544 81.5418 99.1581 81.4807 99.1674H81.4862Z"
        fill="url(#paint36_linear_10_3)"
      />
      <path
        d="M86.0095 102.41C86.1225 102.41 86.217 102.453 86.2948 102.538C86.3727 102.623 86.4097 102.731 86.4097 102.863C86.4097 103.052 86.3652 103.199 86.2744 103.307C86.1837 103.415 86.0725 103.468 85.9353 103.468C85.8223 103.468 85.7278 103.429 85.65 103.35C85.5722 103.27 85.5351 103.168 85.5351 103.043C85.5351 102.861 85.5888 102.701 85.6963 102.564C85.7741 102.462 85.8779 102.412 86.0095 102.412V102.41Z"
        fill="url(#paint37_linear_10_3)"
      />
      <path
        d="M109.161 98.5174L108.939 98.4078C109.167 97.9528 109.404 97.6371 109.648 97.4607C109.893 97.2842 110.167 97.197 110.471 97.197C110.836 97.197 111.127 97.3121 111.344 97.5442C111.561 97.7764 111.67 98.0475 111.67 98.3577C111.67 98.5489 111.631 98.7439 111.553 98.9408C111.476 99.1376 111.346 99.3438 111.166 99.5592C111.051 99.7003 110.732 99.9956 110.21 100.443C109.509 101.052 109.017 101.544 108.733 101.92C109.113 101.903 109.504 101.894 109.906 101.894C110.036 101.894 110.149 101.894 110.245 101.897C110.456 101.907 110.601 101.886 110.679 101.836C110.757 101.786 110.886 101.621 111.066 101.34H111.366C111.131 101.665 110.927 102.064 110.755 102.538C110.549 102.501 110.332 102.471 110.102 102.453C109.873 102.434 109.634 102.425 109.382 102.425C109.083 102.425 108.644 102.443 108.066 102.48L108.153 102.206C108.416 101.814 108.811 101.37 109.335 100.878C109.854 100.389 110.188 100.049 110.338 99.8545C110.555 99.5722 110.712 99.3066 110.81 99.0578C110.886 98.8721 110.923 98.6919 110.923 98.5174C110.923 98.2555 110.853 98.0475 110.71 97.8897C110.568 97.7337 110.393 97.6538 110.184 97.6538C110.01 97.6538 109.839 97.7169 109.674 97.8414C109.508 97.9677 109.337 98.1905 109.159 98.5155L109.161 98.5174Z"
        fill="url(#paint38_linear_10_3)"
      />
      <path
        d="M114.377 97.2062C114.791 97.2062 115.124 97.3585 115.374 97.6631C115.624 97.9676 115.75 98.4245 115.75 99.0318C115.75 99.8935 115.534 100.696 115.102 101.439C114.67 102.181 114.144 102.551 113.527 102.551C113.165 102.551 112.858 102.393 112.608 102.076C112.358 101.758 112.232 101.327 112.232 100.781C112.232 100.139 112.356 99.5109 112.606 98.8962C112.856 98.2815 113.136 97.8469 113.449 97.5888C113.762 97.3307 114.072 97.2025 114.379 97.2025L114.377 97.2062ZM114.3 97.4625C114.12 97.4625 113.936 97.5832 113.751 97.8228C113.564 98.0624 113.392 98.5006 113.234 99.1376C113.077 99.7746 112.997 100.382 112.997 100.961C112.997 101.426 113.064 101.765 113.199 101.977C113.334 102.189 113.488 102.295 113.662 102.295C113.816 102.295 113.968 102.219 114.118 102.064C114.34 101.834 114.542 101.403 114.722 100.768C114.902 100.133 114.991 99.496 114.991 98.8535C114.991 98.3576 114.915 97.9844 114.765 97.7374C114.652 97.5554 114.496 97.4625 114.3 97.4625Z"
        fill="url(#paint39_linear_10_3)"
      />
      <path
        d="M116.988 98.5174L116.766 98.4078C116.994 97.9528 117.231 97.6371 117.476 97.4607C117.72 97.2842 117.994 97.197 118.298 97.197C118.663 97.197 118.954 97.3121 119.171 97.5442C119.388 97.7764 119.497 98.0475 119.497 98.3577C119.497 98.5489 119.458 98.7439 119.381 98.9408C119.303 99.1376 119.173 99.3438 118.993 99.5592C118.878 99.7003 118.56 99.9956 118.037 100.443C117.337 101.052 116.844 101.544 116.56 101.92C116.94 101.903 117.331 101.894 117.733 101.894C117.863 101.894 117.976 101.894 118.072 101.897C118.284 101.907 118.428 101.886 118.506 101.836C118.584 101.786 118.713 101.621 118.893 101.34H119.193C118.958 101.665 118.754 102.064 118.582 102.538C118.376 102.501 118.159 102.471 117.93 102.453C117.7 102.434 117.461 102.425 117.209 102.425C116.91 102.425 116.471 102.443 115.893 102.48L115.98 102.206C116.243 101.814 116.638 101.37 117.162 100.878C117.681 100.389 118.015 100.049 118.165 99.8545C118.382 99.5722 118.539 99.3066 118.637 99.0578C118.713 98.8721 118.75 98.6919 118.75 98.5174C118.75 98.2555 118.68 98.0475 118.537 97.8897C118.395 97.7337 118.221 97.6538 118.011 97.6538C117.837 97.6538 117.666 97.7169 117.502 97.8414C117.335 97.9677 117.164 98.1905 116.986 98.5155L116.988 98.5174Z"
        fill="url(#paint40_linear_10_3)"
      />
      <path
        d="M120.9 98.5174L120.678 98.4078C120.906 97.9528 121.143 97.6371 121.387 97.4607C121.632 97.2842 121.906 97.197 122.21 97.197C122.575 97.197 122.866 97.3121 123.083 97.5442C123.3 97.7764 123.409 98.0475 123.409 98.3577C123.409 98.5489 123.37 98.7439 123.292 98.9408C123.214 99.1376 123.085 99.3438 122.905 99.5592C122.79 99.7003 122.471 99.9956 121.949 100.443C121.248 101.052 120.755 101.544 120.472 101.92C120.852 101.903 121.243 101.894 121.645 101.894C121.775 101.894 121.888 101.894 121.984 101.897C122.195 101.907 122.34 101.886 122.418 101.836C122.495 101.786 122.625 101.621 122.805 101.34H123.105C122.87 101.665 122.666 102.064 122.494 102.538C122.288 102.501 122.071 102.471 121.841 102.453C121.612 102.434 121.373 102.425 121.121 102.425C120.822 102.425 120.383 102.443 119.805 102.48L119.892 102.206C120.155 101.814 120.55 101.37 121.074 100.878C121.593 100.389 121.927 100.049 122.077 99.8545C122.293 99.5722 122.451 99.3066 122.549 99.0578C122.625 98.8721 122.662 98.6919 122.662 98.5174C122.662 98.2555 122.592 98.0475 122.449 97.8897C122.306 97.7337 122.132 97.6538 121.923 97.6538C121.749 97.6538 121.578 97.7169 121.413 97.8414C121.247 97.9677 121.076 98.1905 120.898 98.5155L120.9 98.5174Z"
        fill="url(#paint41_linear_10_3)"
      />
      <path
        d="M42.7414 155.339L43.9996 156.697C43.1305 157.263 42.2096 157.479 41.2368 157.343C40.2639 157.207 39.4097 156.741 38.674 155.948C37.8142 155.02 37.477 154.026 37.666 152.968C37.855 151.909 38.5443 150.921 39.7377 150.002C40.9532 149.066 42.1429 148.605 43.3084 148.622C44.4721 148.639 45.5024 149.129 46.3956 150.095C47.0979 150.854 47.4462 151.67 47.4388 152.546C47.4314 153.423 47.0719 154.195 46.3604 154.866L45.0948 153.499C45.4542 153.114 45.6266 152.719 45.608 152.312C45.5895 151.905 45.3875 151.495 45.0002 151.075C44.5463 150.585 43.9626 150.368 43.2491 150.423C42.5357 150.479 41.7945 150.802 41.0274 151.393C40.2658 151.98 39.8007 152.593 39.6283 153.233C39.4579 153.874 39.6061 154.448 40.0768 154.957C40.4307 155.339 40.8495 155.566 41.3331 155.636C41.8168 155.707 42.2856 155.608 42.7414 155.337V155.339ZM42.6877 155.711C42.1855 155.943 41.6833 156.01 41.1756 155.907C40.6697 155.805 40.2287 155.553 39.8525 155.146C39.3189 154.57 39.1373 153.92 39.3059 153.198C39.4764 152.476 39.9749 151.796 40.8069 151.157C41.6592 150.5 42.482 150.156 43.2732 150.126C44.0626 150.095 44.7353 150.379 45.2893 150.977C45.6729 151.391 45.8841 151.818 45.9231 152.255C45.9601 152.691 45.8211 153.111 45.5043 153.514L46.3474 154.424C46.8977 153.811 47.1553 153.129 47.1238 152.383C47.0923 151.634 46.7717 150.932 46.1621 150.275C45.3338 149.382 44.3776 148.932 43.2918 148.923C42.2059 148.915 41.0904 149.35 39.9471 150.232C38.8241 151.098 38.1682 152.021 37.981 153.001C37.7938 153.982 38.0996 154.903 38.8964 155.763C39.532 156.45 40.2713 156.869 41.1108 157.024C41.9502 157.178 42.7544 157.042 43.5215 156.613L42.6877 155.712V155.711Z"
        fill="url(#paint42_linear_10_3)"
      />
      <path
        d="M45.9305 156.608C46.9941 155.54 48.1189 154.951 49.3048 154.845C50.4908 154.739 51.6118 155.122 52.6662 155.993C53.7187 156.862 54.245 157.837 54.245 158.923C54.245 160.008 53.7132 161.085 52.6495 162.153C51.5859 163.221 50.4611 163.809 49.2752 163.915C48.0893 164.021 46.97 163.64 45.9175 162.771C44.8613 161.9 44.3332 160.922 44.335 159.837C44.335 158.753 44.8669 157.675 45.9305 156.608ZM46.1825 156.816C45.1763 157.826 44.6686 158.834 44.6612 159.839C44.6519 160.845 45.1429 161.755 46.1325 162.573C47.1053 163.375 48.143 163.722 49.2474 163.611C50.3499 163.501 51.4006 162.944 52.3975 161.943C53.4056 160.931 53.917 159.921 53.9281 158.914C53.9392 157.908 53.4538 156.999 52.4717 156.188C51.4951 155.382 50.4537 155.033 49.3475 155.142C48.2412 155.25 47.1868 155.807 46.1825 156.816ZM47.1405 157.607C47.9206 156.823 48.7045 156.375 49.4938 156.264C50.2832 156.153 51.0226 156.381 51.7119 156.949C52.3957 157.514 52.7125 158.158 52.6644 158.884C52.6162 159.611 52.203 160.364 51.4265 161.144C50.6501 161.924 49.8663 162.372 49.0769 162.487C48.2875 162.602 47.5519 162.378 46.8681 161.813C46.1788 161.245 45.8564 160.595 45.9045 159.869C45.9509 159.141 46.3641 158.387 47.1405 157.607ZM47.3925 157.815C46.6828 158.528 46.2974 159.215 46.2399 159.874C46.1825 160.535 46.4567 161.115 47.0645 161.616C47.6723 162.118 48.3283 162.309 49.0361 162.194C49.7421 162.077 50.4556 161.657 51.1745 160.936C51.888 160.22 52.2734 159.534 52.3308 158.877C52.3883 158.22 52.1177 157.642 51.5173 157.146C50.9077 156.643 50.2462 156.448 49.5346 156.563C48.823 156.678 48.1096 157.096 47.3925 157.815Z"
        fill="url(#paint43_linear_10_3)"
      />
      <path
        d="M51.2338 166.552L56.7317 159.458L62.1611 162.935L61.2049 164.168L57.3506 161.7L56.1035 163.308L59.4779 165.47L58.5217 166.703L55.1474 164.541L52.807 167.561L51.2319 166.552H51.2338ZM51.6822 166.502L52.7144 167.163L55.0547 164.144L58.4198 166.298L59.0239 165.518L55.6588 163.364L57.2561 161.302L61.0937 163.759L61.6941 162.985L56.8244 159.867L51.6822 166.502Z"
        fill="url(#paint44_linear_10_3)"
      />
      <path
        d="M58.3068 170.933L62.9412 163.349L68.7504 166.272L67.9444 167.59L63.8195 165.514L62.7689 167.234L66.3804 169.052L65.5743 170.371L61.9628 168.552L59.9893 171.782L58.3049 170.933H58.3068ZM58.7478 170.839L59.8522 171.394L61.8257 168.164L65.4261 169.977L65.9357 169.143L62.3353 167.33L63.6824 165.126L67.7906 167.193L68.2964 166.365L63.0839 163.741L58.7478 170.837V170.839Z"
        fill="url(#paint45_linear_10_3)"
      />
      <path
        d="M65.9542 174.649L69.6232 166.641L75.9883 169.032L75.3509 170.423L70.7665 168.701L69.9845 170.408L74.1761 171.983L73.5479 173.353L69.3564 171.778L68.4132 173.838L73.2292 175.647L72.551 177.125L65.9542 174.647V174.649ZM66.3749 174.508L72.3471 176.752L72.79 175.784L67.9851 173.979L69.1581 171.418L73.3552 172.995L73.7536 172.126L69.5565 170.549L70.572 168.331L75.1452 170.049L75.5455 169.175L69.8067 167.018L66.3749 174.51V174.508Z"
        fill="url(#paint46_linear_10_3)"
      />
      <path
        d="M74.7394 177.79L77.3373 169.446L83.973 171.126L83.5208 172.577L78.74 171.366L78.186 173.145L82.5573 174.252L82.1125 175.68L77.7413 174.573L77.0723 176.72L82.094 177.992L81.6141 179.534L74.7357 177.792L74.7394 177.79ZM75.1396 177.604L81.3658 179.183L81.6789 178.174L76.6684 176.906L77.4985 174.237L81.8754 175.346L82.157 174.439L77.7802 173.331L78.4991 171.021L83.267 172.228L83.5505 171.316L77.5652 169.799L75.1359 177.604H75.1396Z"
        fill="url(#paint47_linear_10_3)"
      />
      <path
        d="M89.9008 175.881L89.5784 175.403C89.4135 175.149 89.3005 174.917 89.2393 174.709C89.1782 174.501 89.1615 174.282 89.1874 174.051C89.2578 173.431 89.5321 172.956 90.0139 172.623C90.4938 172.291 91.1109 172.159 91.865 172.226C92.5877 172.289 93.1399 172.512 93.5216 172.889C93.9034 173.268 94.0609 173.743 93.996 174.317C93.946 174.753 93.7792 175.134 93.4939 175.457C93.2085 175.78 92.786 176.072 92.2245 176.328L93.3845 177.931C93.5365 177.771 93.6643 177.587 93.7644 177.377C93.8663 177.168 93.9552 176.898 94.0312 176.571L95.7008 176.72C95.5989 177.234 95.4358 177.695 95.2079 178.098C94.98 178.501 94.6798 178.876 94.3036 179.22L95.8083 181.279L93.6254 181.086L93.0436 180.273C92.6748 180.559 92.2486 180.768 91.7705 180.902C91.2906 181.034 90.8014 181.079 90.2992 181.034C89.4265 180.956 88.739 180.657 88.2387 180.137C87.7384 179.617 87.529 178.989 87.6124 178.256C87.6735 177.714 87.8718 177.266 88.209 176.913C88.5444 176.56 89.1096 176.217 89.9045 175.881H89.9008ZM93.1751 179.905L93.8163 180.824L94.8113 180.911C94.8966 180.919 94.9818 180.932 95.0671 180.949C95.1523 180.965 95.245 180.989 95.345 181.017C95.2616 180.947 95.1857 180.874 95.1134 180.798C95.0411 180.722 94.9744 180.637 94.9114 180.542L93.9182 179.184C94.2906 178.87 94.5908 178.533 94.8206 178.17C95.0485 177.808 95.219 177.405 95.3302 176.963L94.2517 176.867C94.1813 177.184 94.072 177.463 93.9238 177.706C93.7755 177.949 93.5754 178.174 93.3215 178.38L91.7576 176.22C92.3987 175.942 92.8657 175.656 93.1585 175.361C93.4512 175.065 93.6199 174.714 93.6662 174.309C93.7218 173.817 93.5828 173.411 93.2511 173.084C92.9176 172.759 92.4413 172.569 91.8206 172.514C91.1702 172.456 90.6383 172.567 90.227 172.852C89.8137 173.134 89.5784 173.542 89.5173 174.077C89.495 174.276 89.5098 174.465 89.5636 174.646C89.6173 174.826 89.7174 175.024 89.8656 175.242L90.3419 175.964C89.4172 176.378 88.8039 176.744 88.5 177.064C88.1961 177.381 88.0163 177.788 87.9607 178.284C87.8866 178.932 88.0738 179.487 88.5185 179.949C88.9632 180.412 89.5636 180.677 90.3215 180.744C90.8014 180.787 91.2739 180.739 91.7409 180.601C92.2078 180.464 92.6878 180.232 93.1788 179.905H93.1751ZM90.8199 176.648L92.6229 179.171C92.1597 179.485 91.7891 179.688 91.513 179.779C91.2369 179.87 90.9422 179.903 90.6291 179.875C90.1454 179.832 89.7656 179.662 89.4913 179.361C89.2171 179.06 89.1022 178.696 89.1522 178.267C89.1837 177.994 89.2671 177.764 89.4061 177.578C89.5432 177.39 89.7674 177.212 90.0769 177.043L90.8218 176.648H90.8199ZM90.7125 177.028L90.1732 177.318C89.962 177.429 89.8008 177.561 89.6877 177.712C89.5747 177.864 89.508 178.046 89.4839 178.261C89.445 178.612 89.5321 178.913 89.7489 179.162C89.9657 179.411 90.2659 179.554 90.6513 179.587C90.9422 179.613 91.2054 179.587 91.4407 179.509C91.676 179.431 91.9225 179.29 92.1801 179.084L90.7143 177.028H90.7125ZM91.3147 175.604L90.9793 175.138C90.7921 174.881 90.6717 174.672 90.6161 174.512C90.5605 174.352 90.542 174.185 90.5624 174.014C90.5957 173.726 90.7125 173.511 90.9163 173.372C91.1201 173.232 91.3962 173.177 91.7427 173.208C92.0763 173.238 92.3302 173.34 92.5062 173.515C92.6804 173.689 92.7526 173.916 92.7211 174.192C92.6896 174.473 92.6007 174.703 92.4543 174.883C92.3079 175.063 92.0689 175.236 91.7353 175.4L91.3166 175.604H91.3147ZM91.4314 175.255L91.6853 175.13C91.904 175.024 92.0763 174.891 92.1967 174.729C92.319 174.568 92.3913 174.386 92.4154 174.178C92.4376 173.979 92.3857 173.814 92.256 173.685C92.1282 173.555 91.9466 173.481 91.7112 173.461C91.4666 173.438 91.2721 173.479 91.1275 173.58C90.9811 173.682 90.8978 173.836 90.8737 174.042C90.8589 174.179 90.8737 174.311 90.9163 174.439C90.9608 174.568 91.0404 174.709 91.1572 174.865L91.4314 175.255Z"
        fill="url(#paint48_linear_10_3)"
      />
      <path
        d="M101.632 181.251L100.963 172.618L105.012 172.335C106.03 172.265 106.817 172.447 107.379 172.881C107.938 173.316 108.253 173.988 108.325 174.898C108.394 175.786 108.186 176.49 107.703 177.01C107.219 177.53 106.493 177.825 105.522 177.892L103.352 178.042L103.589 181.114L101.632 181.249V181.251ZM101.945 180.952L103.233 180.863L102.996 177.792L105.5 177.617C106.374 177.556 107.026 177.294 107.453 176.833C107.879 176.371 108.06 175.734 107.997 174.922C107.933 174.098 107.651 173.492 107.147 173.104C106.645 172.716 105.931 172.555 105.009 172.62L101.319 172.876L101.945 180.952ZM102.918 176.794L102.681 173.741L104.857 173.589C105.457 173.546 105.911 173.639 106.215 173.866C106.519 174.092 106.691 174.464 106.732 174.98C106.773 175.496 106.656 175.892 106.383 176.168C106.111 176.445 105.681 176.603 105.094 176.644L102.918 176.796V176.794ZM103.244 176.495L105.034 176.371C105.546 176.336 105.909 176.209 106.124 175.992C106.341 175.775 106.432 175.446 106.396 175.004C106.363 174.569 106.224 174.261 105.981 174.077C105.739 173.893 105.357 173.821 104.838 173.856L103.048 173.981L103.243 176.495H103.244Z"
        fill="url(#paint49_linear_10_3)"
      />
      <path
        d="M109.699 176.33C109.389 174.922 109.541 173.75 110.154 172.818C110.768 171.886 111.776 171.288 113.177 171.024C114.574 170.762 115.75 170.95 116.71 171.587C117.67 172.224 118.304 173.247 118.615 174.655C118.925 176.064 118.773 177.234 118.159 178.167C117.546 179.099 116.54 179.697 115.145 179.959C113.744 180.222 112.563 180.035 111.603 179.398C110.644 178.761 110.01 177.738 109.699 176.33ZM110.034 176.267C110.327 177.598 110.916 178.564 111.802 179.16C112.687 179.758 113.784 179.933 115.098 179.688C116.39 179.444 117.314 178.887 117.876 178.013C118.437 177.138 118.573 176.04 118.282 174.72C117.987 173.385 117.4 172.417 116.516 171.817C115.632 171.217 114.539 171.041 113.236 171.284C111.941 171.528 111.01 172.086 110.445 172.961C109.88 173.838 109.743 174.939 110.036 176.267H110.034ZM111.305 176.027C111.077 174.995 111.149 174.155 111.522 173.511C111.894 172.866 112.537 172.456 113.453 172.285C114.359 172.114 115.12 172.261 115.734 172.723C116.347 173.186 116.768 173.931 116.994 174.959C117.22 175.988 117.15 176.826 116.779 177.472C116.41 178.118 115.771 178.527 114.865 178.698C113.949 178.871 113.184 178.726 112.567 178.263C111.952 177.801 111.531 177.056 111.303 176.027H111.305ZM111.64 175.964C111.848 176.904 112.226 177.589 112.775 178.02C113.325 178.451 114.001 178.59 114.807 178.438C115.613 178.287 116.175 177.918 116.494 177.329C116.812 176.742 116.868 175.972 116.657 175.021C116.449 174.077 116.071 173.39 115.524 172.961C114.978 172.532 114.305 172.393 113.508 172.543C112.699 172.696 112.132 173.067 111.809 173.656C111.487 174.246 111.429 175.015 111.639 175.962L111.64 175.964Z"
        fill="url(#paint50_linear_10_3)"
      />
      <path
        d="M119.868 174.339C119.345 172.985 119.318 171.806 119.785 170.807C120.251 169.806 121.158 169.087 122.507 168.651C123.85 168.214 125.047 168.252 126.094 168.76C127.143 169.269 127.927 170.202 128.449 171.555C128.972 172.909 129 174.088 128.533 175.088C128.066 176.089 127.161 176.807 125.816 177.242C124.467 177.68 123.27 177.643 122.221 177.134C121.172 176.625 120.389 175.693 119.866 174.339H119.868ZM120.19 174.235C120.683 175.517 121.415 176.395 122.382 176.874C123.35 177.353 124.465 177.389 125.729 176.978C126.971 176.575 127.804 175.905 128.227 174.969C128.649 174.033 128.616 172.93 128.127 171.659C127.632 170.374 126.9 169.492 125.935 169.011C124.967 168.53 123.857 168.493 122.603 168.9C121.356 169.305 120.52 169.975 120.094 170.913C119.668 171.851 119.699 172.958 120.192 174.235H120.19ZM121.415 173.838C121.033 172.844 120.976 172.005 121.247 171.32C121.517 170.634 122.092 170.148 122.974 169.862C123.846 169.579 124.623 169.628 125.301 170.007C125.979 170.387 126.509 171.071 126.891 172.061C127.273 173.05 127.328 173.888 127.061 174.575C126.795 175.262 126.224 175.747 125.351 176.031C124.471 176.317 123.689 176.271 123.009 175.892C122.329 175.513 121.797 174.828 121.415 173.84V173.838ZM121.738 173.734C122.086 174.638 122.566 175.268 123.176 175.624C123.785 175.981 124.478 176.033 125.255 175.782C126.029 175.531 126.531 175.093 126.757 174.473C126.984 173.851 126.921 173.084 126.568 172.168C126.218 171.26 125.74 170.629 125.132 170.274C124.525 169.919 123.837 169.865 123.07 170.114C122.29 170.367 121.786 170.805 121.556 171.431C121.326 172.055 121.387 172.824 121.738 173.736V173.734Z"
        fill="url(#paint51_linear_10_3)"
      />
      <path
        d="M132.081 174.727L127.841 167L129.593 166.196L133.05 172.497L137.197 170.592L137.981 172.018L132.083 174.725L132.081 174.727ZM132.241 174.345L137.538 171.912L137.025 170.978L132.883 172.88L129.429 166.584L128.275 167.115L132.242 174.345H132.241Z"
        fill="url(#paint52_linear_10_3)"
      />
      <path
        d="M143.116 169.16L137.507 162.197L141.07 159.805C141.869 159.269 142.601 159.014 143.268 159.04C143.935 159.066 144.504 159.373 144.975 159.96C145.236 160.285 145.384 160.615 145.421 160.951C145.458 161.289 145.378 161.627 145.186 161.965C145.695 161.841 146.159 161.852 146.574 161.995C146.989 162.138 147.367 162.422 147.708 162.844C148.245 163.512 148.419 164.192 148.227 164.883C148.034 165.575 147.493 166.22 146.6 166.82L143.114 169.158L143.116 169.16ZM143.203 168.759L146.159 166.777C146.735 166.391 147.143 166.069 147.38 165.811C147.617 165.555 147.784 165.284 147.878 164.996C147.978 164.677 147.991 164.344 147.917 164.003C147.841 163.659 147.684 163.34 147.443 163.039C147.094 162.608 146.705 162.337 146.273 162.225C145.842 162.114 145.315 162.149 144.695 162.327C144.982 161.98 145.126 161.62 145.13 161.248C145.134 160.877 144.995 160.519 144.717 160.171C144.272 159.62 143.759 159.341 143.177 159.337C142.595 159.332 141.9 159.601 141.094 160.142L137.957 162.246L143.203 168.759ZM141.085 164.276L139.547 162.366L141.747 160.892C142.175 160.606 142.558 160.468 142.899 160.483C143.24 160.498 143.535 160.66 143.787 160.972C144.05 161.299 144.139 161.616 144.05 161.921C143.961 162.225 143.696 162.526 143.255 162.821L141.087 164.276H141.085ZM141.18 163.886L143.003 162.662C143.399 162.396 143.635 162.145 143.713 161.913C143.79 161.679 143.72 161.429 143.505 161.161C143.299 160.905 143.066 160.777 142.805 160.775C142.543 160.773 142.223 160.899 141.845 161.154L139.984 162.402L141.18 163.886ZM143.518 167.297L141.702 165.043L143.902 163.568C144.415 163.223 144.865 163.061 145.249 163.083C145.632 163.106 145.983 163.312 146.298 163.702C146.613 164.092 146.724 164.458 146.629 164.796C146.535 165.134 146.229 165.479 145.708 165.828L143.52 167.297H143.518ZM143.605 166.896L145.477 165.641C145.957 165.319 146.235 165.028 146.311 164.768C146.387 164.508 146.292 164.212 146.025 163.882C145.764 163.557 145.479 163.388 145.171 163.373C144.863 163.358 144.48 163.505 144.02 163.813L142.139 165.076L143.605 166.896Z"
        fill="url(#paint53_linear_10_3)"
      />
      <path
        d="M150.61 164.055L146.533 155.666L148.191 154.225L157.201 158.329L155.628 159.696L153.819 158.814L151.29 161.011L152.172 162.699L150.611 164.055H150.61ZM150.724 163.575L151.81 162.632L150.913 160.955L153.762 158.481L155.589 159.347L156.662 158.415L148.238 154.57L146.907 155.725L150.723 163.574L150.724 163.575ZM150.419 160.01L148.23 155.868L152.742 157.991L150.419 160.01ZM150.509 159.549L152.214 158.067L149.37 156.691C149.216 156.619 149.086 156.552 148.979 156.492C148.871 156.433 148.773 156.37 148.688 156.305C148.773 156.414 148.849 156.518 148.918 156.619C148.986 156.719 149.049 156.819 149.107 156.92L150.509 159.549Z"
        fill="url(#paint54_linear_10_3)"
      />
      <path
        d="M158.405 157.072L151.043 151.632L153.661 148.7C154.165 148.135 154.584 147.747 154.916 147.536C155.249 147.324 155.605 147.194 155.985 147.146C156.33 147.107 156.669 147.138 157.004 147.238C157.34 147.339 157.673 147.511 158.003 147.757C158.455 148.091 158.744 148.451 158.868 148.836C158.993 149.22 158.954 149.645 158.755 150.11C159.119 149.857 159.484 149.749 159.851 149.788C160.217 149.827 160.658 150.024 161.175 150.381L162.078 150.995C162.095 151.008 162.119 151.025 162.148 151.047C162.573 151.346 162.904 151.447 163.141 151.348L163.366 151.514L162.009 153.033C161.855 152.999 161.698 152.945 161.537 152.869C161.376 152.793 161.179 152.674 160.948 152.513L160.153 151.956C159.678 151.631 159.3 151.482 159.015 151.506C158.729 151.53 158.422 151.729 158.094 152.097L156.784 153.566L159.647 155.683L158.405 157.074V157.072ZM158.383 156.66L159.2 155.744L156.346 153.634L157.812 151.993C158.214 151.541 158.594 151.285 158.948 151.222C159.302 151.161 159.693 151.276 160.121 151.573L160.925 152.121C160.959 152.139 161.001 152.169 161.055 152.208C161.433 152.472 161.728 152.63 161.937 152.678L162.864 151.64C162.732 151.658 162.6 151.645 162.471 151.601C162.341 151.556 162.137 151.436 161.859 151.241L160.96 150.622C160.477 150.284 160.052 150.11 159.686 150.095C159.321 150.08 158.881 150.223 158.37 150.524C158.603 149.957 158.678 149.478 158.592 149.086C158.505 148.694 158.25 148.34 157.823 148.024C157.16 147.534 156.528 147.342 155.93 147.452C155.329 147.56 154.705 147.979 154.054 148.707L151.497 151.571L158.383 156.66ZM155.527 153.031L153.118 151.25L154.818 149.348C155.166 148.958 155.539 148.735 155.935 148.678C156.332 148.622 156.721 148.735 157.104 149.018C157.497 149.307 157.705 149.634 157.727 149.993C157.749 150.353 157.582 150.73 157.228 151.127L155.529 153.029L155.527 153.031ZM155.505 152.618L156.975 150.971C157.277 150.633 157.421 150.323 157.408 150.039C157.395 149.757 157.225 149.493 156.895 149.25C156.573 149.01 156.254 148.915 155.941 148.962C155.627 149.008 155.324 149.198 155.027 149.53L153.558 151.177L155.507 152.618H155.505Z"
        fill="url(#paint55_linear_10_3)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_10_3"
          x1="2.41034"
          y1="97.9398"
          x2="193.457"
          y2="97.9398"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_10_3"
          x1="34.236"
          y1="97.9398"
          x2="161.631"
          y2="97.9398"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_10_3"
          x1="19.8455"
          y1="47.4711"
          x2="43.7809"
          y2="47.4711"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_10_3"
          x1="35.5109"
          y1="34.8595"
          x2="62.4038"
          y2="34.8595"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_10_3"
          x1="57.3673"
          y1="23.9398"
          x2="80.4689"
          y2="23.9398"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_10_3"
          x1="90.3196"
          y1="18.7046"
          x2="105.729"
          y2="18.7046"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_10_3"
          x1="107.382"
          y1="20.1309"
          x2="115.836"
          y2="20.1309"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_10_3"
          x1="114.881"
          y1="24.82"
          x2="137.611"
          y2="24.82"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_10_3"
          x1="135.129"
          y1="35.9181"
          x2="156.921"
          y2="35.9181"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_10_3"
          x1="150.534"
          y1="48.1323"
          x2="174.528"
          y2="48.1323"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_10_3"
          x1="57.3747"
          y1="123.661"
          x2="92.9231"
          y2="123.661"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_10_3"
          x1="103.098"
          y1="122.455"
          x2="140.201"
          y2="122.455"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_10_3"
          x1="172.038"
          y1="99.0113"
          x2="180.501"
          y2="99.0113"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_10_3"
          x1="175.472"
          y1="98.5526"
          x2="183.33"
          y2="98.5526"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_10_3"
          x1="171.99"
          y1="98.8943"
          x2="176.07"
          y2="98.8943"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_10_3"
          x1="177.932"
          y1="96.9927"
          x2="183.33"
          y2="96.9927"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_10_3"
          x1="13.5748"
          y1="98.8758"
          x2="22.0487"
          y2="98.8758"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_10_3"
          x1="16.6638"
          y1="99.652"
          x2="24.4613"
          y2="99.652"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_10_3"
          x1="13.5748"
          y1="98.1719"
          x2="18.1907"
          y2="98.1719"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_10_3"
          x1="20.5533"
          y1="99.9195"
          x2="24.4613"
          y2="99.9195"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_10_3"
          x1="104.873"
          y1="71.1362"
          x2="110.455"
          y2="71.1362"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint21_linear_10_3"
          x1="85.183"
          y1="71.6933"
          x2="111.881"
          y2="71.6933"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint22_linear_10_3"
          x1="94.7983"
          y1="57.0167"
          x2="100.328"
          y2="57.0167"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint23_linear_10_3"
          x1="91.6982"
          y1="57.8783"
          x2="95.6507"
          y2="57.8783"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint24_linear_10_3"
          x1="98.6396"
          y1="58.9425"
          x2="102.299"
          y2="58.9425"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint25_linear_10_3"
          x1="92.8953"
          y1="129.797"
          x2="104.566"
          y2="129.797"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint26_linear_10_3"
          x1="93.3419"
          y1="130.53"
          x2="102.598"
          y2="130.53"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint27_linear_10_3"
          x1="96.3142"
          y1="128.823"
          x2="101.286"
          y2="130.168"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint28_linear_10_3"
          x1="85.0403"
          y1="130.643"
          x2="111.854"
          y2="130.643"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint29_linear_10_3"
          x1="84.3603"
          y1="130.643"
          x2="112.532"
          y2="130.643"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint30_linear_10_3"
          x1="87.9644"
          y1="134.151"
          x2="109.558"
          y2="134.151"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint31_linear_10_3"
          x1="87.6939"
          y1="126.177"
          x2="93.5439"
          y2="126.177"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint32_linear_10_3"
          x1="94.2684"
          y1="121.638"
          x2="96.7941"
          y2="121.638"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint33_linear_10_3"
          x1="65.1926"
          y1="100.829"
          x2="70.5256"
          y2="100.829"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint34_linear_10_3"
          x1="70.2866"
          y1="101.071"
          x2="74.8821"
          y2="101.071"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint35_linear_10_3"
          x1="74.9173"
          y1="100.452"
          x2="80.7061"
          y2="100.452"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint36_linear_10_3"
          x1="79.2774"
          y1="100.766"
          x2="85.3479"
          y2="100.766"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint37_linear_10_3"
          x1="85.5351"
          y1="102.937"
          x2="86.4079"
          y2="102.937"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint38_linear_10_3"
          x1="108.068"
          y1="99.8675"
          x2="111.672"
          y2="99.8675"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint39_linear_10_3"
          x1="112.232"
          y1="99.8786"
          x2="115.75"
          y2="99.8786"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint40_linear_10_3"
          x1="115.893"
          y1="99.8675"
          x2="119.497"
          y2="99.8675"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint41_linear_10_3"
          x1="119.807"
          y1="99.8675"
          x2="123.411"
          y2="99.8675"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint42_linear_10_3"
          x1="37.5993"
          y1="153.151"
          x2="47.4481"
          y2="152.854"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint43_linear_10_3"
          x1="44.3239"
          y1="159.531"
          x2="54.2562"
          y2="159.229"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint44_linear_10_3"
          x1="51.1448"
          y1="163.62"
          x2="62.1704"
          y2="163.285"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint45_linear_10_3"
          x1="58.2086"
          y1="167.665"
          x2="68.7838"
          y2="167.343"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint46_linear_10_3"
          x1="65.8745"
          y1="172.044"
          x2="76.0699"
          y2="171.733"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint47_linear_10_3"
          x1="74.6449"
          y1="174.638"
          x2="84.0712"
          y2="174.352"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint48_linear_10_3"
          x1="87.5401"
          y1="176.93"
          x2="95.699"
          y2="176.682"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint49_linear_10_3"
          x1="101.093"
          y1="176.859"
          x2="108.383"
          y2="176.637"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint50_linear_10_3"
          x1="109.56"
          y1="175.634"
          x2="118.754"
          y2="175.354"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint51_linear_10_3"
          x1="119.475"
          y1="173.091"
          x2="128.842"
          y2="172.806"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint52_linear_10_3"
          x1="127.949"
          y1="170.551"
          x2="137.926"
          y2="170.247"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint53_linear_10_3"
          x1="137.572"
          y1="164.268"
          x2="148.295"
          y2="163.943"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint54_linear_10_3"
          x1="146.64"
          y1="159.224"
          x2="157.216"
          y2="158.902"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
        <linearGradient
          id="paint55_linear_10_3"
          x1="151.065"
          y1="152.292"
          x2="163.381"
          y2="151.918"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#401617" />
          <stop offset="0.08" stopColor="#6B4C2D" />
          <stop offset="0.38" stopColor="#A48955" />
          <stop offset="0.56" stopColor="#E4D3B4" />
          <stop offset="0.8" stopColor="#957858" />
          <stop offset="0.96" stopColor="#804F2E" />
        </linearGradient>
      </defs>
    </svg>
  );
};
